
import Vue from 'vue'
import Map from 'ol/Map';
import OSM from 'ol/source/OSM';
import VectorLayer from "ol/layer/Vector";
import View from 'ol/View';
import {DoubleClickZoom} from 'ol/interaction';
import proj4 from "proj4"

import VectorTileLayer from 'ol/layer/VectorTile';
import VectorTileSource from 'ol/source/VectorTile';
import XYZ from 'ol/source/XYZ';
import TileWMS from 'ol/source/TileWMS';
import Tile from 'ol/layer/Tile';
import TileImage from "ol/source/TileImage";
import Vector from 'ol/source/Vector';
import VectorSource from 'ol/source/Vector';
import TileLayer from "ol/layer/Tile"
// import Image from "ol/layer/Image"
// import ImageStatic from "ol/source/ImageStatic"
import TileGrid from 'ol/tilegrid/TileGrid'

import Projection from 'ol/proj/Projection';
import createXYZ from "ol/tilegrid/TileGrid";
import { OverviewMap, MousePosition, ZoomSlider, Rotate, ScaleLine, FullScreen, ZoomToExtent } from "ol/control";
import { Style, Fill as olFill, Stroke, Icon as olIcon, Text as olText, Circle as olCircle, RegularShape } from "ol/style";
import { Point, MultiLineString, Circle, MultiPolygon, Polygon, LineString, LinearRing } from 'ol/geom';
import { transform, fromLonLat, addProjection, addCoordinateTransforms, getTransform } from "ol/proj";
import { fromExtent } from "ol/geom/Polygon";
import MVT from "ol/format/MVT";
import * as turf from '@turf/turf'
import GeoJSON from "ol/format/GeoJSON";
import { bbox } from 'ol/loadingstrategy';
import And from 'ol/format/filter/And';
import Bbox from 'ol/format/filter/Bbox';
import Intersects from 'ol/format/filter/Intersects';
import EqualTo from 'ol/format/filter/EqualTo';

import LessThanOrEqualTo from 'ol/format/filter/LessThanOrEqualTo';
import Or from 'ol/format/filter/Or';
import { Feature } from 'ol';
import WFS from 'ol/format/WFS';

import Overlay from 'ol/Overlay';

// import { lineString as tLineString } from '@turf/turf';
// import { WindLayer } from "ol-wind";
import { ajax } from 'jquery';

import { getSingleWeather,getWeatherData } from "../http/axios";
import { getCenter as getFeatureCenter } from 'ol/extent';
import { Math } from 'core-js';
let echarts = require('echarts/lib/echarts');






var mapCfg, layerCfg, hyGisCfg, layerStyleCfg,  voltageLevel,weatherCfg,asiaHeatline;
var selectOverlay = null;

var map = null;
var mapCenterXY;
var lastLayerName = ''
var lastLayerStyleObj = null;
var lastLayerCfg = null;
var lastReturn = null;
var lastName = '';
var lastId = '';
var lastVoltageInfo = null;

var voltageLevelFilter = [];
var plantTypeFilter = [];
var subStationTypeFilter = [];
var commVectorSource = null;
let pointLabelList = [];
let lineLabelList = [];
let isNameMask = 0;
// var displayLineTextLayer = null;
// var displayLineTextSource = null;

// var displaySubStationTextLayer = null;
// var displaySubStationTextSource = null;
var displayLabelLayer = null;
var displayLabelSource = null;

var displayLineConnectLayer = null;
var displayLineConnectSource = null;

var displaySelectedLayer = null
var displaySelectedSource = null;

var breakDownLayer = null;
var breakDownSource = null;

const projection_epsg_no = '900913';
var hyResolutions;
var defaultResolutions = new Array(15);


var weatherTipDelay=null;
const maxResolution = 360 / 512;
var hyFullExtent;
var tileGrid;

var featureStyle;
var selectedStyle;
var breakdownStyle;

var totalElementCount = 0;

var initExten=[]
////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
///==================================
//解决百度 的 偏移问题
const gcj02Extent = [-20037508.342789244, -20037508.342789244, 20037508.342789244, 20037508.342789244];
const gcjMecator = new Projection({
    code: "GCJ-02",
    extent: gcj02Extent,
    units: "m"
});
addProjection(gcjMecator);

var forEachPoint = function (func) {
    return function (input, opt_output, opt_dimension) {
        var len = input.length;
        var dimension = opt_dimension ? opt_dimension : 2;
        var output;
        if (opt_output) {
            output = opt_output;
        } else {
            if (dimension !== 2) {
                output = input.slice();
            } else {
                output = new Array(len);
            }
        }
        for (var offset = 0; offset < len; offset += dimension) {
            func(input, output, offset)
        }
        return output;
    };
};
var gcj02 = {};
var i = 0;
var PI = Math.PI;
var AXIS = 6378245.0;
var OFFSET = 0.00669342162296594323;  // (a^2 - b^2) / a^2

function delta(wgLon, wgLat) {
    var dLat = transformLat(wgLon - 105.0, wgLat - 35.0);
    var dLon = transformLon(wgLon - 105.0, wgLat - 35.0);
    var radLat = wgLat / 180.0 * PI;
    var magic = Math.sin(radLat);
    magic = 1 - OFFSET * magic * magic;
    var sqrtMagic = Math.sqrt(magic);
    dLat = (dLat * 180.0) / ((AXIS * (1 - OFFSET)) / (magic * sqrtMagic) * PI);
    dLon = (dLon * 180.0) / (AXIS / sqrtMagic * Math.cos(radLat) * PI);
    return [dLon, dLat];
}

function outOfChina(lon, lat) {
    if (lon < 72.004 || lon > 137.8347) {
        return true;
    }
    if (lat < 0.8293 || lat > 55.8271) {
        return true;
    }
    return false;
}

function transformLat(x, y) {
    var ret = -100.0 + 2.0 * x + 3.0 * y + 0.2 * y * y + 0.1 * x * y + 0.2 * Math.sqrt(Math.abs(x));
    ret += (20.0 * Math.sin(6.0 * x * PI) + 20.0 * Math.sin(2.0 * x * PI)) * 2.0 / 3.0;
    ret += (20.0 * Math.sin(y * PI) + 40.0 * Math.sin(y / 3.0 * PI)) * 2.0 / 3.0;
    ret += (160.0 * Math.sin(y / 12.0 * PI) + 320 * Math.sin(y * PI / 30.0)) * 2.0 / 3.0;
    return ret;
}

function transformLon(x, y) {
    var ret = 300.0 + x + 2.0 * y + 0.1 * x * x + 0.1 * x * y + 0.1 * Math.sqrt(Math.abs(x));
    ret += (20.0 * Math.sin(6.0 * x * PI) + 20.0 * Math.sin(2.0 * x * PI)) * 2.0 / 3.0;
    ret += (20.0 * Math.sin(x * PI) + 40.0 * Math.sin(x / 3.0 * PI)) * 2.0 / 3.0;
    ret += (150.0 * Math.sin(x / 12.0 * PI) + 300.0 * Math.sin(x / 30.0 * PI)) * 2.0 / 3.0;
    return ret;
}

gcj02.toWGS84 = forEachPoint(
    function (input, output, offset) {
        var lng = input[offset];
        var lat = input[offset + 1];
        if (!outOfChina(lng, lat)) {
            var deltaD = delta(lng, lat);
            lng = lng - deltaD[0];
            lat = lat - deltaD[1];
        }
        output[offset] = lng;
        output[offset + 1] = lat;
    });

gcj02.fromWGS84 = forEachPoint(function (input, output, offset) {
    var lng = input[offset];
    var lat = input[offset + 1];
    if (!outOfChina(lng, lat)) {
        var deltaD = delta(lng, lat);
        lng = lng + deltaD[0];
        lat = lat + deltaD[1];
    }
    output[offset] = lng;
    output[offset + 1] = lat;
});

var sphericalMercator = {}

var RADIUS = 6378137;
var MAX_LATITUDE = 85.0511287798;
var RAD_PER_DEG = Math.PI / 180;

sphericalMercator.forward = forEachPoint(function (input, output, offset) {
    var lat = Math.max(Math.min(MAX_LATITUDE, input[offset + 1]), -MAX_LATITUDE);
    var sin = Math.sin(lat * RAD_PER_DEG);

    output[offset] = RADIUS * input[offset] * RAD_PER_DEG;
    output[offset + 1] = RADIUS * Math.log((1 + sin) / (1 - sin)) / 2;
});

sphericalMercator.inverse = forEachPoint(function (input, output, offset) {
    output[offset] = input[offset] / RADIUS / RAD_PER_DEG;
    output[offset + 1] = (2 * Math.atan(Math.exp(input[offset + 1] / RADIUS)) - (Math.PI / 2)) / RAD_PER_DEG;
});


var projzh = {};
projzh.ll2gmerc = function (input, opt_output, opt_dimension) {
    let output = gcj02.fromWGS84(input, opt_output, opt_dimension);
    return projzh.ll2smerc(output, output, opt_dimension);
};
projzh.gmerc2ll = function (input, opt_output, opt_dimension) {
    let output = projzh.smerc2ll(input, input, opt_dimension);
    return gcj02.toWGS84(output, opt_output, opt_dimension);
};
projzh.smerc2gmerc = function (input, opt_output, opt_dimension) {
    let output = projzh.smerc2ll(input, input, opt_dimension);
    output = gcj02.fromWGS84(output, output, opt_dimension);
    return projzh.ll2smerc(output, output, opt_dimension);
};
projzh.gmerc2smerc = function (input, opt_output, opt_dimension) {
    let output = projzh.smerc2ll(input, input, opt_dimension);
    output = gcj02.toWGS84(output, output, opt_dimension);
    return projzh.ll2smerc(output, output, opt_dimension);
};

projzh.ll2smerc = sphericalMercator.forward;
projzh.smerc2ll = sphericalMercator.inverse;

addCoordinateTransforms("EPSG:4326", gcjMecator, projzh.ll2gmerc, projzh.gmerc2ll);
addCoordinateTransforms("EPSG:3857", gcjMecator, projzh.smerc2gmerc, projzh.gmerc2smerc);

////////////////////////////////////////////////////////////////////////////////////////////////
//huayu 2385

//定义自定义坐标系
proj4.defs("EPSG:2385", "+proj=tmerc +lat_0=0 +lon_0=120 +k=1 +x_0=500000 +y_0=0 +ellps=IAU76 +units=m +no_defs +type=crs");

var Epsg2385_projection = new Projection({
    code: 'EPSG:2385',
    extent: hyFullExtent,//[345754.23,2501018.29,607809.05,5528581.54],
    // units: 'm',
    units: "esriMeters",
    axisOrientation: 'neu',
    global: false,
    getPointResolution(r) {
        return r;
    }
});

//结合proj4在ol3中自定义坐标系
addProjection(Epsg2385_projection);
addCoordinateTransforms("EPSG:4326", "EPSG:2385",
    function (coordinate) {
        return proj4("EPSG:4326", "EPSG:2385", coordinate);
    },
    function (coordinate) {
        return proj4("EPSG:2385", "EPSG:4326", coordinate);
    }
);
addCoordinateTransforms("EPSG:3857", "EPSG:2385",
    function (coordinate) {
        return proj4("EPSG:3857", "EPSG:2385", coordinate);
    },
    function (coordinate) {
        return proj4("EPSG:2385", "EPSG:3857", coordinate);
    }
);
function initgraphdata() {
    ajax({
        method: "GET",
        url: window.common.getConfPath("voltageLevel.json"),
        async: false
    }).done(function (msg) {
        voltageLevel = msg;
        window.global.voltageLevel = msg;
    });

    ajax({
        method: "GET",
        url: window.common.getConfPath("colorCfg.json"),
        async: false
    }).done(function (msg) {
        window.global.colorCfg = msg;
    });

}
function initMapBase() {


    ajax({
        method: "GET",
        url: window.common.getConfPath("mapCfg.json"),
        async: false
    }).done(function (msg) {
        mapCfg = msg;
        window.global.mapCfg = msg;
    });
    ajax({
        method: "GET",
        url: window.common.getConfPath("weatherCfg.json"),
        async: false
    }).done(function (msg) {
        weatherCfg = msg;
        window.global.weatherCfg = msg;
    });

    ajax({
        method: "GET",
        url: window.common.getConfPath("layerCfg.json"),
        async: false
    }).done(function (msg) {
        layerCfg = msg;
        window.global.layerCfg = msg;
    });
    ajax({
        method: "GET",
        url: window.common.getConfPath("hyGisCfg.json"),
        async: false
    }).done(function (msg) {
        hyGisCfg = msg;
    });
    ajax({
        method: "GET",
        url: window.common.getConfPath("layerStyleCfg.json"),
        async: false
    }).done(function (msg) {
        layerStyleCfg = msg;
        window.global.layerStyleCfg = msg;
    });
    ajax({
        method: "GET",
        url: window.common.getConfPath("voltageLevel.json"),
        async: false
    }).done(function (msg) {
        // layerStyleCfg = msg;
        window.global.voltageLevelOptions = msg;
    });
    ajax({
        method: "GET",
        url: window.common.getConfPath("drawLine.json"),
        async: false
    }).done(function (msg) {
        // layerStyleCfg = msg;
        window.global.drawLineCfg = msg;
    });
    ajax({
        method: "GET",
        url: window.common.getConfPath("topicCfg.json"),
        async: false
    }).done(function (msg) {
        window.global.topicCfg = msg;
    });


    ajax({
        method: "GET",
        url: window.common.getConfPath("contextMenuCfg.json"),
        async: false
    }).done(function (msg) {
        // layerStyleCfg = msg;
        window.global.contextMenuCfg = msg;
    });

    ajax({
        method: "GET",
        url: window.common.getConfPath("dataTypes.json"),
        async: false
    }).done(function (msg) {
        // layerStyleCfg = msg;
        window.global.dataTypes = msg;
        for (let key in window.global.dataTypes) {
            let upkey = key.toUpperCase();
            window.global.dataTypes[upkey] = window.global.dataTypes[key];
        }
    });

    if(window.global.applicationScene == 'asia'  && window.global.asiaCfg==null)
    {
        ajax({
            method: "GET",
            url: window.common.getConfPath("asiaCfg.json"),
            async: false
        }).done(function (msg) {
            // layerStyleCfg = msg;
            window.global.asiaCfg = msg;
        
        });
    }
   




    isNameMask = Number(window.common.safeGetJsonKey(mapCfg, "isMask", 0));

    hyResolutions = new Array(hyGisCfg.lods.length + 1);

    for (let i = 0; i < 14; ++i) {
        defaultResolutions[i] = maxResolution / Math.pow(2, i + 1);
    }


    for (let i = 0; i < hyGisCfg.lods.length; ++i) {
        hyResolutions[i] = hyGisCfg.lods[i].resolution;
    }
    //var resolutions = [0.00237946100583028, 0.00118973050291514, 5.9486525145757E-4, 2.97432625728785E-4, 1.5228550437313792E-4, 7.614275218656896E-5, 3.807137609328448E-5, 1.903568804664224E-5, 9.51784402332112E-6, 4.75892201166056E-6];
    //地图范围
    //var fullExtent = [112.01082395876296, 27.323495453608288, 114.13457604123721, 29.19250454639183];
    hyFullExtent = [parseFloat(hyGisCfg.fullExtent.xmin), parseFloat(hyGisCfg.fullExtent.ymin),
    parseFloat(hyGisCfg.fullExtent.xmax), parseFloat(hyGisCfg.fullExtent.ymax)];


    featureStyle = new Style({
        fill: new olFill({
            color: "#efefef"
        }),
        stroke: new Stroke({
            color: '#8d8d8d', //颜色
            width: 0, //宽度
            lineCap: mapCfg.style.lineCap, //线帽样式
            //butt：末端添加平直边缘；round：末端添加圆形线帽；square：末端添加方形线帽；
            lineJoin: mapCfg.style.lineJoin, //线条连接处样式
            //bevel：创建斜角；round：创建圆角；square：创建尖角；
            // lineDash:[2,3,1,2]
        }),
        text: new olText({

            rotateWithView: true,
            overflow: true,
            rotation: 0,
            placement: "point",
            font: mapCfg.text.fontSize + "px " + mapCfg.text.font,
            textBaseline: mapCfg.text.textBaseline, //文本基线
            offsetX: parseInt(mapCfg.text.offsetX),
            fill: new olFill({
                color: "#efefef"
            }),
            // stroke: new Stroke({
            //     color: '#8d8d8d', //颜色
            //     width: 0 //宽度
            // }),      
        })
    });
    selectedStyle = new Style({
        text: new olText({
            backgroundFill: new olFill({
                color: "rgba(250,249,240,0.5)"
            }),
            backgroundStroke: new Stroke({
                color: 'rgba(200,199,180,0.5)', //颜色
                width: 1 //宽度
            }),
            rotateWithView: true,
            overflow: true,
            rotation: 0,
            placement: "point",
            font: (parseInt(mapCfg.text.fontSize) + 4) + "px " + mapCfg.text.font,
            textBaseline: mapCfg.text.textBaseline, //文本基线
            offsetX: parseInt(mapCfg.text.offsetX),
            fill: new olFill({
                color: "#161823"
            })
        }),
        fill: new olFill({
            color: layerStyleCfg.selected_style.fill,
        }),
        stroke: new Stroke({
            color: layerStyleCfg.selected_style.color,
            width: layerStyleCfg.selected_style.width,
        })
    });

    breakdownStyle = new Style({
        text: new olText({
            backgroundFill: new olFill({
                color: "rgba(250,249,240,0.7)"
            }),
            backgroundStroke: new Stroke({
                color: 'rgba(200,199,180,0.7)', //颜色
                width: 1 //宽度
            }),
            rotateWithView: true,
            overflow: true,
            rotation: 0,
            placement: "point",
            font: (parseInt(mapCfg.text.fontSize) + 4) + "px " + mapCfg.text.font,
            textBaseline: mapCfg.text.textBaseline, //文本基线
            offsetX: parseInt(mapCfg.text.offsetX),
            fill: new olFill({
                color: "#161823"
            })
        }),
        fill: new olFill({
            color: layerStyleCfg.breakdown_style.fill,
        }),
        stroke: new Stroke({
            color: layerStyleCfg.breakdown_style.color,
            width: layerStyleCfg.breakdown_style.width,
        })
    });






    ////////////////////////////////////////////////////////////////////////////////////////////////
    //====================================
    tileGrid = new createXYZ({
        tileSize: 512,
        resolutions: defaultResolutions,
        maxZoom: 22,
        origin: [0, 0]
    });





}




function displayLayerbyZoom(curZoom) {
    // console.log(curZoom);
    if(isAsiaFilting())
        return ;
    for (let i = 0; i < layerCfg.length; i++) {
        let jl = layerCfg[i];

        let ly = jl.ol;
        if (ly == null)
            continue;
        let online = window.common.safeGetJsonKey(jl, "online", "0");
        if (online == "0") {
            if (ly.getVisible())
                ly.setVisible(false);
            continue;
        }
        let minZoom = parseInt(window.common.safeGetJsonKey(jl, "minZoom", 14));
        let maxZoom = parseInt(window.common.safeGetJsonKey(jl, "maxZoom", 20));
        let isVisible = parseInt(window.common.safeGetJsonKey(jl, "visible", 1));


        if (jl.tempVisible == 0 || (isVisible == 0 && jl.tempVisible == null)) {//0 means temp force hide
            if (ly.getVisible())
                ly.setVisible(false);
        }
        else if (jl.tempVisible == 1 ||
            (curZoom >= minZoom && curZoom <= maxZoom)) {//1 means temp force display
            //null do nothing
            if (!ly.getVisible()) {
                ly.setVisible(true);
            }

        }
        else {
            if (ly.getVisible())
                ly.setVisible(false);
        }
    }

    if(window.global.applicationScene == 'asia')
    {
        window.asia_displayLayerbyZoom(curZoom);
    }
    if(window.getBgcolor)
        window.getBgcolor()
}


function displayZoomInfo(curZoom) {
    let element = document.getElementById("zoomInfo");
    curZoom = parseInt(curZoom);
    if (element != null)
        element.innerHTML = curZoom;
}
function clearDisplayLabelSource() {
    pointLabelList = []
    displayLabelSource.clear(true);
}
function cleanDisplayLayer() {

    let mapRect = map.getView().calculateExtent(map.getSize());
    pointLabelList = []
    lineLabelList = []
    displayLabelSource.clear(true);
    displayLineConnectLayer.setVisible(false);
    // console.log("clean pointLabelList");
    // displaySubStationTextSource.clear(true);
}

function addZoomEvent() {
    map.on("movestart", function (e) {
        // console.log("movestart",window.common.getMapZoomInt(),Date.now());
        cleanGeoLayer();
        cleanDisplayLayer();
        displayLineConnectSource.clear(true);
        // window.mapHeatLine.hiddenHeatLine();               
    });
    map.on("moveend", function (e) {
        let curZoom = window.common.getMapZoomInt(); //获取当前地图的缩放级别
        // console.log("movesend",curZoom);
        // if(window.global.applicationScene=="asia"){
        //     let t=window.global.map.getView().getZoom()
        //     console.log(t)
        //     if(t<=6.5){
        //         window.changeSupportZoom(0,false)
        //     }else if(t>6.5 && t<=7){
        //         window.changeSupportZoom(1,false)
        //     }else if(t>7 && t<=8){
        //         window.changeSupportZoom(2,false)
        //     }else if(t>8 && t<=9.5){
        //         window.changeSupportZoom(3,false)
        //     }else if(t>9.5) {
        //         window.changeSupportZoom(-1,false)
        //     }
        // }
        window.mapOperator.cleanLayerTempVisible(curZoom);
        displayLayerbyZoom(curZoom);
        if(window.global.applicationScene!="asia"){
            window.mapOperator.updateLayerVisibleInfo();
        }
        window.global.lastZoom = curZoom;
        window.setInfoZoom(curZoom);
        displayZoomInfo(curZoom);
        refreshAllGeoLayer();
        if (window.refreshBDMeasInfo)
        {
            window.refreshBDMeasInfo();
        }

    });
}

function cleanGeoLayer() {
}


function syncWeatherData()
{
    let points=[]
    let ids=[]
    pointLabelList.forEach(f => {
        
        let tid = f.id;
        let jl=f.layer;
        if(tid!="" && jl.syncWeatherData)
        {
            let coor= f.position;
            let p=transform(coor, 'EPSG:3857', 'EPSG:4326');
            points.push(p.join(" "))
            
            ids.push(tid)
        }
    }); 

    let wType=window.global.weatherType[window.global.weatherType.length-1]
    
    var params = {
        type: wType,
        ids:ids.join(","),
        time: window.global.weatherTime,
        point: points.join(",")
    };
    window.showLoading("syncWeather");
    getSingleWeather(params).then(res => {
        window.closeLoading("syncWeather");
        if( !window.global.topicName.includes("weather")|| 
            window.global.weatherType.length==0 ||
             ( window.global.weatherType.length>0 &&wType!=window.global.weatherType[window.global.weatherType.length-1]  ) 
        )
        {
            drawPointDisplayLabelEx();
            return ;
        }

        if (res.status==200) 
        {
            let nextPosition=0;
            let wData = res.data;
            if(wData.hasOwnProperty("error"))
            {
                drawPointDisplayLabelEx();
                return
            }
            wData[0].datas.forEach(d=>{
                let id=d.id;
                let feature=null;
                for(let i=nextPosition;i<pointLabelList.length;i++)
                {
                    let f=pointLabelList[i];
                    let tid = f.id;
                    if(tid==id)
                    {
                        feature=f
                        nextPosition+=1;
                        if(nextPosition>=pointLabelList.length)
                            nextPosition=0;
                        break;
                    }

                }
                if(feature==null)
                {
                    for(let i=0;i<nextPosition;i++)
                    {
                        let f=pointLabelList[i];
                        let tid = f.id;
                        if(tid==id)
                        {
                            feature=f
                            nextPosition+=1;
                            if(nextPosition>=pointLabelList.length)
                                nextPosition=0;
                            break;
                        }    
                    }
                }
                if(feature!=null)
                {
                    let wText=window.mapWeather.changeWeatherData2Text(d.datas);
                    if(wText!="")
                        feature.name+="\n"+wText;
                }
            });
            drawPointDisplayLabelEx();
        }
    });
}

function loadGeojsonData(jl, mapRect, projCode, vectorSource, success, failure) {

    var curZoom = window.common.getMapZoomInt();
    let filterOrArgs = combineCQLFilterXml(jl);
    let myFilter = null;

    if (filterOrArgs.length > 1) {
        try{
            myFilter = new And(
                new Bbox("geom", mapRect, projCode),
                new Or(...filterOrArgs)
            );
        }
        catch(e)
        {
            return console.log(jl.name,filterOrArgs);
        }
    }
    else if (filterOrArgs.length == 1) {
        try{
            myFilter = new And(
                new Bbox("geom", mapRect, projCode),
                filterOrArgs[0]
            );
        }
        catch(e)
        {
            return console.log(jl.name,filterOrArgs);
        }
    }
    else {
        myFilter = new Bbox("geom", mapRect, projCode);
    }

    if (clipFeatures.length > 0) {
        let clipList = [];
        let pointArr = [];
        let firstC = null;
        for (let i = 0, len = clipFeatures.length; i < len; i++) {
            let feature = clipFeatures[i];

            let allCoors = feature.getGeometry().getCoordinates();
            for (let k = 0; k < allCoors.length; k++) {
                let coors = allCoors[k];
                let len = coors.length;
                for (let i = 0; i < len; i++) {
                    let coorTmp = coors[i];
                    for (let j = 0; j < coorTmp.length; j++) {

                        if (firstC == null) {
                            firstC = coorTmp[j];
                            pointArr.push(coorTmp[j]);
                        }
                        else if (firstC[0] == coorTmp[j][0] && firstC[1] == coorTmp[j][1]) {
                            pointArr.push(coorTmp[j]);

                            let g = new Polygon([pointArr]);
                            clipList.push(new Intersects("geom", g, projCode));
                            pointArr = [];
                            firstC = null;
                        }
                        else {
                            pointArr.push(coorTmp[j]);
                        }
                    }
                }
            }
        }
        if (clipList.length > 0) {
            if (clipList.length >= 2)
                myFilter = new And(myFilter, new Or(...clipList));
            else
                myFilter = new And(myFilter, clipList[0]);
        }
    }
    if(window.global.applicationScene=="asia" && !window.global.showAllLines)
    {
        let teq = new EqualTo("is_asia", "1");
        teq.matchCase = false;
        myFilter = new And(myFilter, teq);
        
        if(window.global.asiaCfg.displayZoomCtrl.includes(jl.name))
        {
            let leq = new LessThanOrEqualTo("displayzoom", curZoom);
            // leq.Number=true;
            leq.matchCase = false;
            myFilter = new And(myFilter, leq);
        }

    }
    let url = mapCfg.wfsUrl + mapCfg.geoWorkSpace + ":" + jl.geolayerName + "&outputFormat=application/json&maxFeatures=50000" + '&srs=' + projCode;
    var featureRequest = new WFS().writeGetFeature({
        srsName: projCode,
        featureNS: 'http://' + mapCfg.geoNamespace,
        featurePrefix: mapCfg.geoWorkSpace, //工作区名称
        featureTypes: [mapCfg.geoWorkSpace + ":" + jl.geolayerName],
        outputFormat: 'application/json',
        filter: myFilter
    });

    jl.loadRenderStep = 1;
    window.showLoading("layer");
    fetch(url, { //geoserver wfs地址如localhost:8080/geoserver/wfs，我是8081
        method: 'POST',
        body: new XMLSerializer().serializeToString(featureRequest)
    }).then(function (response) {
        console.log('867')
        window.closeLoading("layer");
        let t = response.json();
        return t;

    }).then(function (json) {
        let displayFeatures = [];
        let features = vectorSource.getFormat().readFeatures(json);

        if (jl.type == "windAngle") {
            for (let j = 0; j < features.length; j++) {
                let feature = features[j];
                feature.values_.layer = jl;
                // feature.setProperties(report);
                // let st = getFeatureStyleEx(jl,feature, "geoJson");
                // feature.setStyle(() => {
                //     return st;
                // }); //设置要素样式;
                // if(st!=null)
                displayFeatures.push(feature);
            }
        }
        else {
            for (let j = 0; j < features.length; j++) {
                let feature = features[j];
                feature.values_.layer = jl;
                let fetProp = window.common.getFeatureProperties(feature);
                let idField = window.common.safeGetJsonKey(jl, "idfield", window.global.mapCfg.text.idfield)             
                let tid = window.common.safeGetJsonKey(fetProp, idField, "");
                if(window.global.applicationScene=='asia')
                {
                    if(!window.asiaTableFilter(jl,tid)){
                         continue
                        }
                }
                let st = getFeatureStyleEx(jl, feature, "geoJson");
                feature.setStyle(() => {
                    return st;
                }); //设置要素样式;

                if (st != null ){
                    displayFeatures.push(feature);
                }
            }
        }
        if (success == null) {
            vectorSource.clear(true);
        }


        vectorSource.addFeatures(displayFeatures);
        
        if (success == null)
            vectorSource.removeLoadedExtent(mapRect);

        jl.loadRenderStep = 0;
        let allLoaded = checkAllLayerLoaed();
        // console.log(jl.geolayerName," load over!","All layer is",allLoaded?"":"NOT","loaded");

        if (allLoaded) {
            drawSpecialLine();
            drawPointDisplayLabel();
            drawLineDisplayLabel(curZoom);
            drawSationConnectLine();
            if(window.global.applicationScene == 'asia')
                window.mapHeatLine.refreshHeatLineAuto();
        }
        if (success != null)
            success(features);
    })
    .catch((err) => {
        jl.loadRenderStep = 0;
        let allLoaded = checkAllLayerLoaed();
        // console.log(err, jl.geolayerName, " load failed!", "All layer is", allLoaded ? "" : "NOT", "loaded");
        if (allLoaded) {

            drawPointDisplayLabel();
            drawLineDisplayLabel(curZoom);
            drawSationConnectLine();
            if(window.global.applicationScene == 'asia')
                window.mapHeatLine.refreshHeatLineAuto();
            // window.mapHeatLine.refreshHeatLineAuto();
        }
        if (failure != null)
            failure([]);
    });
}

function refreshGeoLayer(layerList, appendlabelLayer) {
    let mList = layerList;
    if (appendlabelLayer) {
        for (let i = 0; i < layerCfg.length; i++) {
            let jl = layerCfg[i];
            if (jl.ol == null)
                continue;
            jl.featureIdList = [];
            if (jl.type == "geoJson" && jl.ol.getVisible() && !jl.loadRenderStep && jl.displayByLabel) {
                if (mList.indexOf(jl) != -1)
                    continue;
                // console.log(jl.geolayerName,"need load");
                jl.loadRenderStep = 1;
                //必须要在这里置1，如果只是在 loadGeojsonData 会导致不同步
                mList.push(jl);
            }
        }
    }
    if (mList.length <= 0) {
        return;
    }
    const projCode = "EPSG:3857";
    let mapRect = map.getView().calculateExtent(map.getSize());
    // let t0 = transform([mapRect[0], mapRect[1]], 'EPSG:3857', 'EPSG:4326');
    // let t1 = transform([mapRect[2], mapRect[3]], 'EPSG:3857', 'EPSG:4326');
    // console.log(t0,t1)

    cleanDisplayLayer();

    // window.mapHeatLine.hiddenHeatLine();
    for (let i = 0; i < mList.length; i++) {
        let jl = mList[i];
        if (jl.ol == null)
            continue;
        jl.featureIdList = [];
        // jl.ol.getSource(
        loadGeojsonData(jl, mapRect, projCode, jl.ol.getSource(), null, null);
    }
}
function refreshAllGeoLayer() {
    // console.log("refreshAllGeoLayer start");

    
    let mList = [];
    for (let i = 0; i < layerCfg.length; i++) {
        let jl = layerCfg[i];
        if (jl.ol == null)
            continue;
        jl.featureIdList = [];
        if ((jl.type == "geoJson" || jl.type == "windAngle") && jl.ol.getVisible() && !jl.loadRenderStep) {
            // if ((jl.type == "geoJson" )  && jl.ol.getVisible() && !jl.loadRenderStep) {
            // console.log(jl.geolayerName,"need load");
            // if(jl.type=="windAngle")
            // {
            //     map.removeLayer(jl.ol);
            //     jl.ol=createMapLayer(jl.name,jl);
            //     map.addLayer(jl.ol);
            // }
            // else
            {
                jl.loadRenderStep = 1;
                //必须要在这里置1，如果只是在 loadGeojsonData 会导致不同步
                mList.push(jl);
            }
        }
        // else if (jl.type == "weather" && jl.ol.getVisible()) {
        //     let mapRect = map.getView().calculateExtent(map.getSize());
        //     let iSt=new ImageStatic({
        //         url: jl.url,
        //         imageExtent: mapRect,
        //         imageLoadFunction:function(image, src) {


        //             let mapRect = map.getView().calculateExtent(map.getSize());
        //             let pixel = map.getPixelFromCoordinate([mapRect[0],mapRect[1]]);
        //             let tx = pixel[0];
        //             let ty= pixel[1];

        //             pixel = map.getPixelFromCoordinate([mapRect[2],mapRect[3]]);
        //             let bx = pixel[0] ;
        //             let by= pixel[1];
        //             let width = parseInt(bx-tx);
        //             let height = parseInt(ty-by);
        //             console.log(width,height);


        //             image.extent=mapRect;
        //             mapRect = map.getView().calculateExtent(map.getSize());


        //             let p2385Rect=[];
        //             let tp = transform([mapRect[0], mapRect[1]], 'EPSG:3857', 'EPSG:2385');
        //             let br = transform([mapRect[2], mapRect[3]], 'EPSG:3857', 'EPSG:2385');
        //             p2385Rect[0]=tp[0]+5000;
        //             p2385Rect[1]=tp[1]-1000;
        //             p2385Rect[2]=br[0]+5000;
        //             p2385Rect[3]=br[1]-6000;

        //             image.getImage().src = src+"?format=png&transparent=true&dpi=96&bboxSR=2385&imageSR=2385&f=image&access_token=64b60040-5181-455f-a47c-4c795190a5fc&bbox="+p2385Rect.join(',')+"&size="+width+","+height
        //         }
        //         });
        //     jl.ol.setSource(iSt);
        // }
    }
    refreshGeoLayer(mList, false);

    if (window.global.topicName.includes("weather")) 
    {
        window.mapWeather.loadWeatherData()

    }
}

function addLoadEvent() {
    map.on("loadend", function (e) {
        console.log("all layer load over!");
    });
    map.on("loadstart", function (e) {
        console.log("load start!");

    });
}



let windShaft = new RegularShape({
    // points: 2,
    // radius: 4,
    // stroke: new Stroke({
    //   width: 2,
    //   color: 'red',
    // }),

    radius: 10 / Math.SQRT2,
    radius2: 10,
    points: 4,
    scale: 0.2,
    rotateWithView: true,
    fill: new olFill({
        color: 'black',
    }),
});

let windHead = new RegularShape({
    points: 3,
    radius: 5,
    fill: new olFill({
        color: 'black',
    }),
    rotateWithView: true,
});

const windStyles = [new Style({ image: windShaft }), new Style({ image: windHead })];


function createMapLayer(layerName, layerJson) {
    var l = null;
    var vtly = null;
    var st = null;
    if (layerName == "") {
        for (i = 0; i < layerJson.layer.length; i++) {
            l = layerJson.layer[i];
            if (l.name == layerName) {
                break;
            }
        }
        if (l == null)
            return null;
    } else
        l = layerJson;

    var zIndex = window.common.safeGetJsonKey(l, "layerZindex", l.index);

    l.vectorSource = null;
    l.featureIdList = [];

    if (l.type == "vectorTile") {
        l.geoUrl = mapCfg.vectorTileUrl + mapCfg.geoWorkSpace + ":" + l.geolayerName +
            '@EPSG:' + l.epsg + '@pbf/{z}/{x}/{-y}.pbf';

        l.vectorSource = new VectorTileSource({
            tilePixelRatio: 1, // oversampling when > 1
            format: new MVT(),
            url: l.geoUrl
        });
        vtly = new VectorTileLayer({
            style: function (feature) {
                let st = getFeatureStyle(feature, "vectorTile");
                return st;
            },
            opacity: parseFloat(window.common.safeGetJsonKey(l, "opacity", "0.8")), //透明度，作为图层属性进行设置
            source: l.vectorSource,
            declutter: l.declutterMode,
        });
        vtly.setZIndex(zIndex);

    } else if (l.type == "Tile") {
        l.geoUrl = mapCfg.tileUrl + mapCfg.geoWorkSpace + ":" + l.geolayerName;
        l.vectorSource = new TileWMS({
            url: l.geoUrl,
            tilePixelRatio: 1, // oversampling when > 1
            tileGrid: tileGrid,
            params: {
                'FORMAT': 'image/png',
                'VERSION': '1.1.1',
                tiled: true,
                "STYLES": '',
                "LAYERS": l.geolayerName,
                "exceptions": 'application/vnd.ogc.se_inimage',
            },
            serverType: 'geoserver',
            crossOrigin: 'anonymous',
        });

        vtly = new Tile({
            //visible: false,
            source: l.vectorSource,

            style: function (feature) {
                let st = getFeatureStyle(feature, "Tile");
                return st;
            },
        });
        vtly.setZIndex(zIndex);
    } else if (l.type == "wms") {
        l.geoUrl = mapCfg.wmsUrl + mapCfg.geoWorkSpace + ":" + l.geolayerName;
        l.vectorSource = new TileWMS({
            url: l.geoUrl,
            tilePixelRatio: 1, // oversampling when > 1
            tileGrid: new createXYZ({
                maxZoom: l.maxZoom
            }),
            params: {
                'FORMAT': 'image/png',
                'VERSION': '1.1.1',
                tiled: true,
                "STYLES": '',
                "LAYERS": l.geolayerName,
                "exceptions": 'application/vnd.ogc.se_inimage',
            }
        });
        vtly = new Tile({
            //visible: false,
            source: l.vectorSource
        });
        vtly.setZIndex(zIndex);
    }
    else if (l.type == "baidu") {
        // console.log('baidu;>>>',gcjMecator,l.url);
        // return
        vtly = new Tile({
            source: new XYZ({
              projection: gcjMecator,
              url: l.url,
          
              // 👇👇👇 关键：完全仿照你的离线瓦片写法，只染色这一层！
              tileLoadFunction: function (imageTile, src) {
                let img = new Image();
                img.setAttribute('crossOrigin', 'anonymous'); // 解决跨域
          
                img.onload = function () {
                  // 1. 创建 canvas 处理这张瓦片
                  let canvas = document.createElement('canvas');
                  let w = img.width;
                  let h = img.height;
                  canvas.width = w;
                  canvas.height = h;
          
                  let ctx = canvas.getContext('2d');
          
                  // ==============================
                  // ✨ 科技蓝 / 极夜蓝 最终滤镜
                  // ==============================
                  ctx.filter = `
                    grayscale(98%)
                    invert(100%)
                    sepia(20%)
                    hue-rotate(180deg)
                    saturate(1600%)
                    brightness(80%)
                    contrast(90%)
                  `;
          
                  // 画入图片
                  ctx.drawImage(img, 0, 0, w, h);
          
                  // 输出染色后的瓦片
                  imageTile.getImage().src = canvas.toDataURL('image/png');
                };
          
                img.src = src;
              }
            })
          });

        
        
    } else if (l.type == "hygis") {
        let hyOrigin = [hyGisCfg.tileInfo.origin.x + 140, hyGisCfg.tileInfo.origin.y - 10];
        let hyTileGrid = new TileGrid({
            tileSize: 256,
            origin: hyOrigin,
            extent: hyFullExtent,
            resolution: hyResolutions[parseInt(window.global.lastZoom) - 4],
            resolutions: hyResolutions
        });
        // 瓦片数据源
        let hyTileArcGISXYZ = new XYZ({
            tileGrid: hyTileGrid,
            projection: Epsg2385_projection,
            url: l.url,
        });

        vtly = new Tile({
            source: hyTileArcGISXYZ,
            opacity:parseFloat(window.common.safeGetJsonKey(l, "opacity", "0.8")), //透明度，作为图层属性进行设置
        });
    }
    // else if(l.type == "weather"){
    //请保留，以后可能作为参考
    //     let mapRect = map.getView().calculateExtent(map.getSize());
    //     vtly=new Image({
    //         opacity: parseFloat(window.common.safeGetJsonKey(l, "opacity", "0.8")), //透明度，作为图层属性进行设置
    //         source: new ImageStatic({
    //         url: l.url,
    //         imageExtent: mapRect,
    //         imageLoadFunction:function(image, src) {

    //             // const width = parseInt(document.documentElement.clientWidth);
    //             // const height = parseInt(document.documentElement.clientHeight);


    //             let mapRect = map.getView().calculateExtent(map.getSize());
    //             let pixel = map.getPixelFromCoordinate([mapRect[0],mapRect[1]]);
    //             let tx = pixel[0];
    //             let ty= pixel[1];

    //             pixel = map.getPixelFromCoordinate([mapRect[2],mapRect[3]]);
    //             let bx = pixel[0] ;
    //             let by= pixel[1];
    //             let width = parseInt(bx-tx);
    //             let height = parseInt(ty-by);
    //             console.log(width,height);
    //             image.extent=mapRect;
    //             mapRect = map.getView().calculateExtent(map.getSize());


    //             let p2385Rect=[];
    //             let tp = transform([mapRect[0], mapRect[1]], 'EPSG:3857', 'EPSG:2385');
    //             let br = transform([mapRect[2], mapRect[3]], 'EPSG:3857', 'EPSG:2385');
    //             p2385Rect[0]=tp[0]+5000;
    //             p2385Rect[1]=tp[1]-1000;
    //             p2385Rect[2]=br[0]+5000;
    //             p2385Rect[3]=br[1]-6000;



    //             image.getImage().src = l.url+"?format=png&transparent=true&dpi=96&bboxSR=2385&imageSR=2385&f=image&access_token=64b60040-5181-455f-a47c-4c795190a5fc&bbox="+p2385Rect.join(',')+"&size="+width+","+height;
    //           }
    //         })
    //     });
    //     vtly.setZIndex(zIndex+1000);
    // }
    else if (l.type == "windAngle") {
        // l.geoUrl = mapCfg.geoJsonUrl + "/" + mapCfg.geoWorkSpace + "/wms?service=WMS&version=1.1.0&request=GetMap&layers=" +
        //     mapCfg.geoWorkSpace + ":" + l.geolayerName + "&format=geojson&maxfeatures=50000";
        // let url=l.geoUrl+ '&width=' + width + "&height=" + height+'&srs=EPSG:3857' + '&' +
        //     'bbox=' + mapRect.join(',');

        //        vtly=new WindLayer(windJsonData, {
        //            forceRender: false,
        //            windOptions: {
        //            // colorScale: scale,
        //     velocityScale: 1 / 2000,
        //     paths: 2000,
        //     maxAge: 80,
        //     // eslint-disable-next-line no-unused-vars
        //     colorScale: () => {
        //         // console.log(m);
        //         return "#20d06c";
        //     },
        //     lineWidth: 3,
        //     // colorScale: scale,
        //     generateParticleOption: false,
        //     },
        //     // map: map,
        //     // projection: 'EPSG:4326'
        // });

        l.vectorSource = new VectorSource({
            url: "",
            projection: l.epsg,
            format: new GeoJSON(),
            // loader: function(extent, resolution, projection,success,failure) {
            //     success([]);
            //     // console.log(l.geolayerName,"auto load start ");
            //     // l.loadRenderStep=1;
            //     // loadGeojsonData(l, extent, projection.getCode(), this, success, failure);
            // },
            // strategy: bbox

        });
        // const features = [];
        // windJsonData.list.forEach(function (report) {
        //   const feature = new Feature(
        //     new Point(fromLonLat([report.coord.lon+90+120, report.coord.lat-29+30]))
        //   );
        //   let fetprop={"deg":report.wind.deg,"speed":report.wind.speed/10,"layer":l};
        //   feature.setProperties(fetprop);
        //   features.push(feature);
        // });
        vtly = new VectorLayer({
            title: l.geolayerName,
            source: l.vectorSource,
            declutter: l.declutterMode

        });



    }
    else if (l.type == "geoJson") {

        //  http://10.20.1.225:8080/geoserver/test/wms?service=WMS&version=1.1.0&request=GetMap&layers=test%3Adwyzt_convertorstationpsr_b&width=768&height=594&styles=&format=geojson&bbox=117.9,27.02,123.3,31.2
        // const width = parseInt(document.documentElement.clientWidth);
        // const height = parseInt(document.documentElement.clientHeight);
        // let mapRect = map.getView().calculateExtent(map.getSize());
        l.geoUrl = mapCfg.geoJsonUrl + "/" + mapCfg.geoWorkSpace + "/wms?service=WMS&version=1.1.0&request=GetMap&layers=" +
            mapCfg.geoWorkSpace + ":" + l.geolayerName + "&format=geojson&maxfeatures=50000";
        // let url=l.geoUrl+ '&width=' + width + "&height=" + height+'&srs=EPSG:3857' + '&' +
        //         'bbox=' + mapRect.join(',');

        l.vectorSource = new VectorSource({
            url: "",
            projection: l.epsg,
            format: new GeoJSON(),
            loader: function (extent, resolution, projection, success, failure) {
                success([]);
                // console.log(l.geolayerName,"auto load start ");
                // l.loadRenderStep=1;
                // loadGeojsonData(l, extent, projection.getCode(), this, success, failure);
            },
            strategy: bbox

        });

        vtly = new VectorLayer({

            title: l.geolayerName,
            source: l.vectorSource,
            // style: function (feature) {
            //     let st = getFeatureStyle(feature, "geoJson");
            //     return st;
            // },
            declutter: l.declutterMode
        });
        vtly.setZIndex(zIndex);
        // vtly.on('postrender', e => {
        // });         
    }
    else
        return null;
    // vtly.on('prerender', e => {
    //     console.log(vtly.name," render");
    // });



    return vtly;
}


function addScaleLint() {
    if (mapCfg.control.scalelint.visible != '1')
        return;

    var scaleLineControl = new ScaleLine({
        Units: mapCfg.control.scalelint.Units, //单位有5种:degrees imperial us nautical metric

    });

    map.addControl(scaleLineControl);
}

function addRotate() {
    if (mapCfg.control.rotate.visible != '1')
        return;

    var scaleLineControl = new Rotate({
        Units: mapCfg.control.scalelint.Units, //单位有5种:degrees imperial us nautical metric
        autoHide: false,
    });

    map.addControl(scaleLineControl);
}
function addZoomSlider() {
    if (mapCfg.control.zoomslide.visible != '1')
        return;

    var zoomSlider = new ZoomSlider({
        // position: new OpenLayers.Pixel(2, 15)//（右边距，上边距）
    });
    map.addControl(zoomSlider);
}



function addFullScreen() {

    var fullE = new FullScreen();
    map.addControl(fullE);
}
function addZoomToExtent() {
    let fullExtent = [13899673.884826906, 3656757.471533364, 12848093.727588734, 3163252.7635363415];
    map.addControl(new ZoomToExtent(
        {
            extent: fullExtent
        }
    ));
}


function addMousePoint(itemId) {
    if (mapCfg.control.mousepoint.visible != '1')
        return;
    mouseCfg = mapCfg.control.mousepoint;
    var mousePointControl = new MousePosition({
        coordinateFormat: coordinate.createStringXY(parseInt(mouseCfg.round)),
        projection: "EPSG:3857",
        className: 'custom-mouse-position',
        target: document.getElementById(itemId)
    });
    map.addControl(mousePointControl);
}



function completeLayerStyle(layerStyle, jl) {
    //console.log(json);
    let j = 1;
    if (JSON.stringify(layerStyle) == '{}')
        return layerStyle;
    if (window.common.safeGetJsonKey(layerStyle, "inited", 0) == 1)
        return layerStyle
    layerStyle.inited = 1;
    for (let key in layerStyle) {
        if (key == "filter" || key == "inited" || key == "colorFilter" ||  key.endsWith("Filter"))
            continue;
        let temp = layerStyle[key];

        if (window.common.safeGetJsonKey(temp, "isFilter", 0) == 1)
            continue;
        let val = window.common.safeGetJsonKey(temp, "minZoom", "auto");
        temp.minZoom = val;


        temp.unamezoomdelay = parseInt(window.common.safeGetJsonKey(temp, "unamezoomdelay", 1));
        temp.zoomOffset = parseInt(window.common.safeGetJsonKey(temp, "zoomOffset", 0));


        temp.visible = parseInt(window.common.safeGetJsonKey(temp, "visible", 1));
        temp.width = parseInt(window.common.safeGetJsonKey(temp, "width", parseInt(mapCfg.style.width)));
        temp.lineScale = parseFloat(window.common.safeGetJsonKey(temp, "lineScale", parseFloat(mapCfg.style.lineScale)));
        temp.fill = window.common.safeGetJsonKey(temp, "fill", mapCfg.style.fill);
        temp.color = window.common.safeGetJsonKey(temp, "color", mapCfg.style.color);
        temp.colorMode = window.common.safeGetJsonKey(temp, "colorMode", "simple");
        temp.colorStep = parseInt(window.common.safeGetJsonKey(temp, "colorStep", 10));

        temp.lineCap = window.common.safeGetJsonKey(temp, "lineCap", mapCfg.style.lineCap);
        temp.lineJoin = window.common.safeGetJsonKey(temp, "lineJoin", mapCfg.style.lineJoin);
        temp.lineFlash = parseInt(window.common.safeGetJsonKey(temp, "lineFlash", 1));
        
        let t = window.common.safeGetJsonKey(temp, "lineDash", "");
        if (t == "")
            temp.lineDash = null;
        else if (typeof t == "string")
            temp.lineDash = t.split(",");
        t = window.common.safeGetJsonKey(temp, "overlayDash", "");
        if (t == "")
            temp.overlayDash = null;
        else if (typeof t == "string")
            temp.overlayDash = t.split(",");

        if (temp.hasOwnProperty("text")) {

            temp.text.zoomOffset = parseInt(window.common.safeGetJsonKey(temp.text, "zoomOffset", 0));
            temp.text.minZoom = window.common.safeGetJsonKey(temp.text, "minZoom", "auto");
            temp.text.visible = parseInt(window.common.safeGetJsonKey(temp.text, "visible", 1));
            temp.text.offsetX = parseInt(window.common.safeGetJsonKey(temp.text, "offsetX", parseInt(mapCfg.text.offsetX)));
            temp.text.offsetY = parseInt(window.common.safeGetJsonKey(temp.text, "offsetY", parseInt(mapCfg.text.offsetY)));
            temp.text.width = parseInt(window.common.safeGetJsonKey(temp.text, "width", parseInt(mapCfg.text.width)));
            temp.text.color = window.common.safeGetJsonKey(temp.text, "color", "auto");
            temp.text.bordercolor = window.common.safeGetJsonKey(temp.text, "bordercolor", mapCfg.text.bordercolor);
            temp.text.font = " " + window.common.safeGetJsonKey(temp.text, "font", mapCfg.text.font);
            temp.text.fontSize = parseInt(window.common.safeGetJsonKey(temp.text, "fontSize", mapCfg.text.fontSize));
            temp.text.trim = window.common.safeGetJsonKey(temp.text, "trimWord", "");
            temp.text.fill = window.common.safeGetJsonKey(temp.text, "fill", mapCfg.text.fill);
            temp.text.scaleStep = parseFloat(window.common.safeGetJsonKey(temp.text, "0.2", mapCfg.text.scaleStep));
            

        } else {
            var text = eval('({"minZoom":20,"visible":0})');
            text.minZoom = 20;
            text.zoomOffset = -3;
            text.visible = 0;
            text.width = parseInt(mapCfg.text.width);
            text.color = "auto";
            text.bordercolor = mapCfg.text.bordercolor;
            text.font = " " + mapCfg.text.font;
            text.fontSize = 12;
            text.trim = "";
            text.scaleStep = 0.2
            temp.fill = 'rgba(255, 255,170, 0.7)';
            temp.text = text;

        }
        if (temp.hasOwnProperty("image")) {
            temp.image.minZoom = window.common.safeGetJsonKey(temp.image, "minZoom", "auto");
            temp.image.visible = parseInt(window.common.safeGetJsonKey(temp.image, "visible", 1));
            let val =window.common.safeGetJsonKey(temp.image, "scale", mapCfg.image.scale)

            if(parseFloat(val).toString() == "NaN")
            {
                temp.image.scale=val
            }
            else
            {
                temp.image.scale=parseFloat(val);
            }

            val =window.common.safeGetJsonKey(temp.image, "rotation", 0)
  
            if(parseFloat(val).toString() == "NaN")
            {
                temp.image.rotation=val
            }
            else
            {
                temp.image.rotation=parseFloat(val);
            }

            temp.image.opacity = parseFloat(window.common.safeGetJsonKey(temp.image, "opacity", mapCfg.image.opacity));
            temp.image.scaleStep = parseFloat(window.common.safeGetJsonKey(temp.image, "scaleStep", mapCfg.image.scaleStep));


        } else {
            var image = eval('({"minZoom":20,"visible":0})');
            image.minZoom = 20;
            image.visible = 0;
            image.scale = 0.5;
            image.scaleStep = 0.1;
            image.rotation=0;
            image.opacity = 0.9;
            temp.image = image;

        }
    }
    if (layerStyle != null)
        layerStyle.tempMinZoom = null;
    return layerStyle;
}


//设备列表定位
function setMapCenter(lon, lat) {
    let center = transform([lon, lat], 'EPSG:4326', 'EPSG:3857');
    //重新定位
    map.getView().setCenter(center);
}
//设置地图中心
function setMapCenterEx(center) {
    map.getView().setCenter(center);
}

//放大倍数
function setMapZoom(zoom) {

    map.getView().setZoom(zoom);
}



function filterByManual(feature, vectorFrom, jl) {
    let fetProp = window.common.getFeatureProperties(feature);
    let val, i
    if (voltageLevelFilter.length > 0) {
        let vField = window.common.safeGetJsonKey(jl, "voltageFiled", mapCfg.field.voltageFiled);
        if (vField != "") {
            val = window.common.safeGetJsonKey(fetProp, vField, "--**--");
            if (val != '--**--') {
                if (!window.common.valIsInArray(voltageLevelFilter, val))
                    return false
            }

        }
    }

    if (plantTypeFilter.length > 0) {
        let vField = window.common.safeGetJsonKey(jl, "plantTypeFiled", mapCfg.field.plantTypeFiled);
        if (vField != "") {
            val = window.common.safeGetJsonKey(fetProp, vField, "--**--");
            if (val != '--**--') {
                if (!window.common.valIsInArray(plantTypeFilter, val))
                    return false
            }
        }
    }

    if (subStationTypeFilter.length > 0) {
        let vField = window.common.safeGetJsonKey(jl, "subStationTypeFiled", mapCfg.field.subStationTypeFiled);
        val = window.common.safeGetJsonKey(fetProp, vField, "--**--");
        if (val != '--**--') {
            if (!window.common.valIsInArray(subStationTypeFilter, val))
                return false
        }
    }

    return true;
}

function maskName(tname) {
    let nName = '';
    let i = 0;
    if (!isNameMask) {
        return tname
    }
    try {
        nName = tname[0]
        for (i = 1; i < tname.length - 1 && i < 4; i++) {
            if (i % 2 == 1)
                nName += "*";
            else
                nName += tname[i];
        }
        nName += tname[tname.length - 1];

    }
    catch (err) {
        return "****";
    }
    return nName;
}


function getFeatureStyle(feature, vectorFrom) {

    
    var curZoom = window.common.getMapZoomInt();
    var featureVal = "";
    let fetProp = window.common.getFeatureProperties(feature);
    getLayerStyleCfg(feature, vectorFrom);
    var styleObj = lastLayerStyleObj;
    if (styleObj == null)
        return null;
    let tname = window.common.safeGetJsonKey(fetProp, lastLayerCfg.textfield, "");

    let tid = window.common.safeGetJsonKey(fetProp, lastLayerCfg.idfield, "");
    // if(tname!="" && lastLayerName=="gis_osm_roads_free_1"  && feature.getGeometry().type_ == "LineString" )
    // {
    // 	//if(tname=="沪昆线")
    // 	{
    // 		// console.log(tname);
    // 		startFeatureAnimation(feature,tname);

    // 		// trackFeature.setyle(animationTextStyle);
    // 		//return animationTextStyle;
    // 	}
    // }
    // if(lastLayerName=="sg_con_substation_b")
    // {
    //     console.log("111",tname,tid);
    // }
    if(!fetProp["oclass"])
        fetProp["oclass"] = lastLayerCfg.name;

    if ((tid == lastId && tid != "") && lastReturn != null) {
        //console.log(tname);
        lastReturn.getText().setText("");
        return lastReturn;
    }

    if (!filterByManual(feature, vectorFrom, lastLayerCfg)) {
        lastReturn = null;
        return null;
    }


    lastName = tname;
    lastId = tid;



    let matchInfo = loadStyleKey(styleObj, styleObj.filter, fetProp, lastLayerCfg.classNameField, featureVal);
    featureVal = matchInfo[1];
    let key = matchInfo[0];
    styleObj=matchInfo[2];
    if (key != null) {

        if (styleObj[key] == undefined) {
            console.log("error: The filter ", key, " is empty!!!!!");
            return null;
        }
        return getFeatureStyleInSubObj(styleObj, styleObj[key], feature,
            featureVal, curZoom, tname, key, vectorFrom, lastLayerCfg, false);
    }
    else {
        return getFeatureStyleInSubObj(styleObj, styleObj.default, feature,
            featureVal, curZoom, tname, "default", vectorFrom, lastLayerCfg, false);
    }
}



function getWindColor(layer, feature) {

    var featureVal = "";
    let fetProp = window.common.getFeatureProperties(feature);
    // getLayerStyleCfg(feature, vectorFrom);
    var styleObj = layer.style;
    if (styleObj == null)
        return null;
    let tname = window.common.safeGetJsonKey(fetProp, layer.textfield, "");
    let tid = window.common.safeGetJsonKey(fetProp, layer.idfield, "");

    lastName = tname;
    lastId = tid;

    let matchInfo = loadStyleKey(styleObj, styleObj.filter, fetProp, layer.classNameField, featureVal);
    featureVal = matchInfo[1];
    let key = matchInfo[0];
    styleObj=matchInfo[2];
    if (key != null) {

        if (styleObj[key] == undefined) {
            console.log("error: The filter ", key, " is empty!!!!!");
            return "#6e6e6e";
        }
        return getFillColor(layer, styleObj, styleObj[key], fetProp);
    }
    else
        return getFillColor(layer, styleObj, styleObj["default"], fetProp);



}

function getWindFeatureStyle(layer, feature) {
    let fetProp = window.common.getFeatureProperties(feature);
    let angle = fetProp.angle_value;
    if (angle >= 180)
        angle = -((fetProp.angle_value - 180) * Math.PI) / 180;
    else
        angle = fetProp.angle_value * Math.PI / 180;

    const scale = fetProp.speed_value / 5;
    let fcolor = getWindColor(layer, feature);



    windShaft.setScale([0.3 * scale, scale]);
    windShaft.setRotation(angle);


    // windShaft.getFill().setColor(fcolor);

    windHead.setDisplacement([
        0,
        windHead.getRadius() / 2 + windShaft.getRadius() * scale,
    ]);
    windHead.getFill().setColor(fcolor);
    windHead.setRotation(angle);
    // windStyles[0].setImage(shaft);
    return windStyles;


}


function getFeatureStyleEx(layer, feature, vectorFrom,skipLastId) {
    var curZoom = window.common.getMapZoomInt();
    var featureVal = "";
    let fetProp = window.common.getFeatureProperties(feature);
    // getLayerStyleCfg(feature, vectorFrom);
    var styleObj = layer.style;
    if (styleObj == null)
        return null;
    let tname = window.common.safeGetJsonKey(fetProp, layer.textfield, "");

    let tid = window.common.safeGetJsonKey(fetProp, layer.idfield, "");
    fetProp["oclass"] = layer.name;

    if ((!skipLastId && tid == lastId && tid != "") && lastReturn != null) {
        //console.log(tname);
        lastReturn.getText().setText("");
        return lastReturn;
    }

    if (!filterByManual(feature, vectorFrom, layer)) {
        lastReturn = null;
        return null;
    }


    lastName = tname;
    lastId = tid;


    let matchInfo = loadStyleKey(styleObj, styleObj.filter, fetProp, layer.classNameField, featureVal);
    featureVal = matchInfo[1];
    styleObj= matchInfo[2];
    let key = matchInfo[0];
    styleObj=matchInfo[2];
    if (key != null) {

        if (styleObj[key] == undefined) {
            console.log("error: The filter ", key, " is empty!!!!!");
            return null;
        }
        return getFeatureStyleInSubObj(styleObj, styleObj[key], feature,
            featureVal, curZoom, tname, key, vectorFrom, layer, true);
    }
    else
        return getFeatureStyleInSubObj(styleObj, styleObj.default, feature,
            featureVal, curZoom, tname, "default", vectorFrom, layer, true);

}

function loadStyleKey(styleObj, filter, fetProp, ikeyWord, ival) {
    let keyWord = window.common.safeGetJsonKey(filter, "keyword", ikeyWord);
    let val = window.common.safeGetJsonKey(fetProp, keyWord, ival);
    let haveNextFilter = window.common.safeGetJsonKey(filter, "continue", 0);
    let matchInfo = new Array(3);
    matchInfo[0] = null;
    matchInfo[1] = val;
    matchInfo[2] = styleObj;
    for (var key in filter) {
        //遍历过滤器
        let fkey = filter[key];

        if (fkey.length == 0) {
            matchInfo[0] = key;
            //如果这个过滤器关键字长度为0，表示这个过滤器是无条件进入。
            break;
        }
        for (var x = 0; x < fkey.length; x++) {
            if (fkey[x].toUpperCase() == val.toUpperCase()) {
                matchInfo[0] = key;
                //匹配过滤器中的关键字
                break;
            }
        }
        if (matchInfo[0])
            break;

    }
    if (matchInfo[0] == null)
        return matchInfo;//如果没有找到，就返回 null

    if (haveNextFilter == 0)
    {
        if(styleObj[matchInfo[0]] == undefined)
        {
            if(layerStyleCfg[matchInfo[0]]!=undefined)
            {
                styleObj = layerStyleCfg[matchInfo[0]];
                return loadStyleKey(styleObj, styleObj.filter, fetProp, keyWord, val);
            }
        }
        return matchInfo;
    }
    else {
        //表示要是行二次过滤。
        let s = window.common.safeGetJsonKey(styleObj, matchInfo[0], null);
        if (s == null)
            return matchInfo;
        else {
            let isFilter = window.common.safeGetJsonKey(s, "isFilter", 0);
            if (isFilter)
                return loadStyleKey(styleObj, s, fetProp, keyWord, val);
            else
                return matchInfo;
        }
    }
    return matchInfo;
}

function getFillColor(layer, layerStyle, subObj, fetProp) {
    if (subObj.fill.endsWith("Filter")) {
        let cf = window.common.safeGetJsonKey(layerStyle, subObj.fill, null);
        if (cf == null)
            return "#6e6e6e";
        let filterWord = window.common.safeGetJsonKey(cf, "filterWord", layer.classNameField);
        if (filterWord == "")
            return "#6e6e6e";
        let v=""
        if(filterWord != "zoom")
            v = window.common.safeGetJsonKey(fetProp, filterWord, "");
        else
            v =  window.common.getMapZoomInt(); //获取当前地图的缩放级别
        for (let f in cf) {
            let vf = cf[f];
            if (f == "filterWord")
                continue;
            let method = window.common.safeGetJsonKey(vf, "method", "include");
            if (method != "include") {
                if (method == "default") {
                    return vf.color == "auto" ? lastVoltageInfo.styleInfo.hex : vf.color;
                }
                else if (method == "less") {
                    if (parseInt(v) > parseInt(vf.value)) {
                        continue;
                    }
                }
                else if (method == "between") {
                    if (parseInt(v) <= parseInt(vf.value) ||
                        parseInt(v) >= parseInt(vf.maxValue)) {
                        continue;
                    }
                } else if (method == "more") {
                    if (parseInt(v) < parseInt(vf.value)) {
                        continue;
                    }
                }
                else if (method == "default") {
                    if (v != vf.value) {
                        continue;
                    }
                }
                else if (method == "equal") {
                    if (v != vf.value)
                        continue
                }
                else
                    continue
                return vf.color == "auto" ? lastVoltageInfo.styleInfo.hex : vf.color;
            }
            else {
                if (vf.values.length > 0 && vf.values.indexOf(v) == -1)
                    continue;
                return vf.color == "auto" ? lastVoltageInfo.styleInfo.hex : vf.color;
            }
        }
    }
    else if (subObj.fill == "auto")
        return lastVoltageInfo.styleInfo.hex;
    else
        return subObj.fill;
}
function getStrokeColor(layer, layerStyle, subObj, fetProp) {
    if (subObj.color == "filter") {
        let cf = window.common.safeGetJsonKey(layerStyle, "colorFilter", null);
        if (cf == null)
            return "#6e6e6e";
        let filterWord = window.common.safeGetJsonKey(cf, "filterWord", layerStyle.voltageFiled);
        if (filterWord == "")
            return "#6e6e6e";
        let v = window.common.safeGetJsonKey(fetProp, filterWord, "");

        for (let f in cf) {
            let vf = cf[f];
            if (f == "filterWord")
                continue;
            let vfk = vf.filter;
            let method = window.common.safeGetJsonKey(vf, "method", "include");
            if (method != "include") {
                if (method == "default") {
                    return vf.color == "auto" ? lastVoltageInfo.styleInfo.hex : vf.color;
                }
                else if (method == "less") {
                    if (parseInt(v) >= parseInt(vf.value)) {
                        continue;
                    }
                }
                else if (method == "between") {
                    if (parseInt(v) < parseInt(vf.value) ||
                        parseInt(v) > parseInt(vf.maxValue)) {
                        continue;
                    }
                } else if (method == "more") {
                    if (parseInt(v) <= parseInt(vf.value)) {
                        continue;
                    }
                }
                else if (method == "default") {
                    if (v != vf.value) {
                        continue;
                    }
                }
                else if (method == "equal") {
                    if (v != vf.value)
                        continue
                }
                else
                    continue
                return vf.color == "auto" ? lastVoltageInfo.styleInfo.hex : vf.color;
            }
            else {
                if (vf.values.length > 0 && vf.values.indexOf(v) == -1)
                    continue;
                return vf.color == "auto" ? lastVoltageInfo.styleInfo.hex : vf.color;
            }
        }
    }
    else if (subObj.color == "auto")
        return lastVoltageInfo.styleInfo.hex;
    else
        return subObj.color;
}

function checkIdRepeat(tname, layer, fetProp) {
    let tid = window.common.safeGetJsonKey(fetProp, layer.idfield, "");
    try {

        if (layer.featureIdList.indexOf(tid) != -1) {
            // console.log(tid, tname, "is repeat!");
            return false;
        }
        layer.featureIdList.push(tid);
    }
    catch (err) {
        console.log(err.message);
    }


    return true;
}

function drawPointImage(feature,subObj,curZoom, tname, geom, scale,rotation, fclass,opacity) {
    let img = "";
    let iconCfg = window.common.safeGetJsonKey(subObj.image, "icon", null);
    if (iconCfg != null) {
        let filterField=window.common.safeGetJsonKey(iconCfg, "filterWord", "");
        if(filterField!="")
        {
            
            let fetProp = window.common.getFeatureProperties(feature);
            fclass = window.common.safeGetJsonKey(fetProp, filterField, fclass);
        }
        let lowFclass = fclass.toLowerCase();
        img = window.common.safeGetJsonKey(iconCfg, lowFclass, "");
        if (img == "") {
            img = window.common.safeGetJsonKey(iconCfg, fclass, "");
        }
        if (img == "") {
            img = window.common.safeGetJsonKey(iconCfg, "default", "");
        }
    }
    if (img == "")
        img = window.common.safeGetJsonKey(layerStyleCfg.icon_list, "default", "");


    if (img != "") {
        if (img.indexOf("{auto}") != -1) {
            img = img.replace("{auto}", lastVoltageInfo.styleInfo.icon);
        }

        img = "gis/" + img;
        let icon = new olIcon({
            anchor: [0.5, 0.5], //设置图标偏移
            scale: scale, // 图标缩小显示
            crossOrigin: 'anonymous',
            // anchorOrigin: 'center-center', //标注样式的起点位置
            // anchorXUnits: 'pixels', //X方向单位:分数
            // anchorYUnits: 'pixels', //Y方向单位:像素
            // offsetOrigin: 'center', //偏移起点位置的方向
            opacity: subObj.image.opacity*opacity, //透明度
            rotateWithView: false,
            offsetX: 0,
            offsetY: 0,
            rotation: rotation,
            declutterMode: "declutter",
            src: 'img/' + img
        })
        // if(lastLayerCfg.geolayerName=="sg_con_plant_b" || lastLayerCfg.geolayerName=="sg_con_substation_b")
        //     console.log(tname,'img/' + img);
        return icon;
    }
    else
        return null;
}



function getTextRectPoint(point, w, h, xd, yd) {

    let options = { units: 'kilometers' };
    let bearing = 90;
    let br, tl, tr;
    let distance, hExpand = 0;

    let resolution = window.global.map.getView().getResolution();
    if (yd == -1) {//垂直向上时不用多加
        distance = resolution * (hExpand + h / 2) / 1000;
    }
    else
        distance = resolution * (hExpand + h / 2) / 1000;
    tl = turf.destination(point, distance, 0, options);

    if (xd == -1 || xd == 0)
        distance = resolution * ((w + 16) / 2) / 1000;
    else
        distance = resolution * (w / 2) / 1000;
    tl = turf.destination(tl, distance, -90, options);


    if (yd == 1) {
        distance = resolution * (h + hExpand) / 1000;
    } else
        distance = resolution * (hExpand + h / 2) / 1000;
    br = turf.destination(point, distance, -180, options);

    if (xd == -1)
        distance = resolution * (w / 2) / 1000;
    else
        distance = resolution * ((w + 16) / 2) / 1000;


    br = turf.destination(br, distance, 90, options);

    let rect0 = transform(tl.geometry.coordinates, 'EPSG:4326', 'EPSG:3857');
    let rect1 = transform(br.geometry.coordinates, 'EPSG:4326', 'EPSG:3857');

    return [rect0, rect1];

}


function checkElementOverflow(tname, exten, checkAll) {
    if(window.global.aisaLayerLayer!=null)
    {
        // let asiaExten=[]
        // asiaExten.push(exten[0]-50)
        // asiaExten.push(exten[1]-50)
        // asiaExten.push(exten[2]+50)
        // asiaExten.push(exten[3]+50)

        

        let features = window.global.aisaLayerLayer.getSource().getFeaturesInExtent(exten);
        if (features.length != 0) {
            return true;
        }

    }
    for (let i = 0; i < layerCfg.length; i++) {
        let ly = layerCfg[i];
        if (ly.ol == null)
            continue;
        if (ly.type != "geoJson")
            continue;
        if (!ly.ol.getVisible())
            continue;
        let features = ly.ol.getSource().getFeaturesInExtent(exten);

        // const boxFeatures =vectorSource.getFeaturesInExtent(extent).filter((feature) => feature.getGeometry().intersectsExtent(extent));
        if (features.length != 0) {
            let gType = features[0].getGeometry().getType();

            if (checkAll) {
                if (gType == "Point" || gType == "LineString" || gType == "MultiLineString")
                    return true;
            }
            else {
                if (gType == "Point")
                    return true;
            }
        }
    }
    return 0;
}

function getElementCountInExten(tname, exten,xd,yd) {
    let elCount = 0;
    if(window.global.aisaLayerLayer!=null)
    {
        let asiaExten=[]
        let mx=(exten[2]-exten[0])/2,my=(exten[3]-exten[1])/2;
        let absx=mx;
        let absy=my*2;
        if(yd!=0)
            absy=0
        if(xd!=0)
            absx=0

        asiaExten.push(exten[0]-absx+(xd<0?mx*xd:0))
        asiaExten.push(exten[1]-absy+(yd>0?my*yd:0))
        asiaExten.push(exten[2]+absx+(xd>0?mx*xd:0))
        asiaExten.push(exten[3]+absy+(yd<0?my*-yd:0))
        // if(xd==0 && yd==-1)
        // {
        //     displayDebugPolygon("cpoint", asiaExten, "#00ff00", 'rgba(10,56,23,0)');
        //     displayDebugPolygon("cpoint", exten, "#3200ff", 'rgba(10,56,23,0)');
        // }

        let features = window.global.aisaLayerLayer.getSource().getFeaturesInExtent(asiaExten);
        if (features.length != 0) {
            elCount+=10
        }

    }

    for (let i = 0; i < layerCfg.length; i++) {
        let ly = layerCfg[i];
        if (ly.ol == null)
            continue;
        if (ly.type != "geoJson")
            continue;
        if (!ly.ol.getVisible())
            continue;
        let features = ly.ol.getSource().getFeaturesInExtent(exten);
        if (features.length != 0) {
            let gType = features[0].getGeometry().getType();
            if (gType == "Point")
                elCount += features.length + 1000;
            else if (gType == "LineString" || gType == "MultiLineString") {
                elCount += features.length;
                // if(tname=="夏金变")
                // {
                //     for(let f=0;f<features.length;f++)
                //     {
                //         let feature = features[f];
                //         let ex=feature.getGeometry().getExtent();
                //         let rect0=[ex[0],ex[1]];
                //         let rect1=[ex[2],ex[3]];
                //         displayDebugPolygon(tname,[[rect0, [rect0[0], rect1[1]], rect1, [rect1[0], rect0[1]], rect0]], "#ff0000", 'rgba(20,39,123,0)')


                //     }
                // }

            }

        }
    }
    return elCount;
}


function displayDebugPolygon(tname, exten, color, fillColor) {
    // console.log(tname, exten, color, fillColor,'iconImage')
    
    if (tname != "cpoint")
        return;

    // if(tname != "绍兴换流站" && tname!="丹溪变"  && tname!="信安变")
    //     return; 
    // let asiaExten=[]
    // asiaExten.push(exten[0]-150)
    // asiaExten.push(exten[1]-150)
    // asiaExten.push(exten[2]+150)
    // asiaExten.push(exten[3]+150)

    let points = [[[exten[0], exten[1]], [exten[2], exten[1]], [exten[2], exten[3]], [exten[0], exten[3]], [exten[0], exten[1]]]]
    //  let points = [[[asiaExten[0], asiaExten[1]], [asiaExten[2], asiaExten[1]], [asiaExten[2], asiaExten[3]], [asiaExten[0], asiaExten[3]], [asiaExten[0], asiaExten[1]]]]
    let ttt = new Style({
        fill: new olFill({
            color: fillColor
        }),
        stroke: new Stroke({
            color: color, //颜色
            width: 1, //宽度
            lineDash: [2, 2]
        }),
    });
    let oltfeature = new Feature({
        geometry: new Polygon(points), //几何信息
    });
    oltfeature.setStyle(() => {

        return ttt;
    }); //设置要素样式
    displayLineConnectSource.addFeature(oltfeature);
}




function savePointLabelInfo(ly, id,curZoom, subObj, tname, feature, scale, minTextZoom) {
    let geom = feature.getGeometry();
    let pos = geom.getFlatCoordinates();
    let gtype = geom.getType();
    if (gtype == "Polygon" || gtype == "MultiPolygon") {
        pos = getFeatureCenter(l.getExtent())
    }

    let x = parseInt(subObj.text.offsetX);
    let y = parseInt(subObj.text.offsetY);
    let color = getElementColorByGB("color",subObj.text.color);
    let fontSize = parseInt(Math.round(subObj.text.fontSize + (curZoom - minTextZoom)));
    let yoffset = parseInt(scale * 12) + Math.abs(y);
    let xoffset = parseInt(scale * 12) + Math.abs(x);

    pointLabelList.push({
        "font": subObj.text.font,
        "fontSize": fontSize,
        "color": color,
        "xoffset": xoffset,
        "yoffset": yoffset,
        "position": pos,
        "name": tname,
        "layer": ly,
        "id":id,
        "feature": feature
    });

    return;
}
function drawPointDisplayLabel() {
    if (!window.global.labelShow) {
        return
    }
    if(window.global.topicName.includes("weather") && window.global.weatherType.length>0)
        syncWeatherData();
    else
        drawPointDisplayLabelEx();
}
function drawPointDisplayLabelEx() {
    let resolution = window.global.map.getView().getResolution();
    let options = { units: 'kilometers' };
    displayLabelLayer.setVisible(true);
    for (let ss = 0; ss < pointLabelList.length; ss++) {
        let positionList = [];
        let dli = pointLabelList[ss];
        let tname = dli.name;
        let yoffset = parseInt(dli.yoffset);
        let xoffset = parseInt(dli.xoffset);
        let color = dli.color;
        let fontSize = dli.fontSize
        let wh = window.common.computeFontSize(tname, fontSize, dli.font);
        let w = wh.width+12;
        let h = wh.height+6;
        let distance, getIt = 0;
        let rect0, rect1;
        let layer=dli.layer;
        let pos = dli.position;

        let fontInfo = fontSize + "px " + dli.font;

        positionList.push([0, -yoffset - h / 2]);
        positionList.push([0, yoffset + h / 2]);
        positionList.push([xoffset + w / 2, 0]);
        positionList.push([-xoffset - w / 2, 0]);

        positionList.push([-xoffset - w / 2, -yoffset - h / 2]);
        positionList.push([xoffset + w / 2, yoffset + h / 2]);
        positionList.push([xoffset + w / 2, -yoffset - h / 2]);
        positionList.push([-xoffset - w / 2, yoffset + h / 2]);

        // if (tname == "绍兴换流站" || tname == "诸暨变") {
        //     console.log(tname,pos,ss);
        // }

        //         //let fontSize = parseInt(subObj.text.fontSize );
        //     ///////////////////////////////////////////////////////////////////////////////////////////////
        let opacity = layer.opacity;
        let allOverFlowList = [];
        for (let i = 0; i < positionList.length; i++) {
            let offsetXY = positionList[i];
            let point = turf.point(transform(pos, 'EPSG:3857', 'EPSG:4326'));

            let xd, yd;

            if (offsetXY[0] <= 0) {
                distance = resolution * (offsetXY[0]) / 1000;
                point = turf.destination(point, -distance, -90, options);
                if (offsetXY[0] == 0)
                    xd = 0;
                else
                    xd = -1;
            }
            else {
                distance = resolution * (offsetXY[0]) / 1000;
                point = turf.destination(point, distance, 90, options);
                xd = 1;
            }

            if (offsetXY[1] < 0) {
                distance = resolution * (offsetXY[1]) / 1000;
                point = turf.destination(point, -distance, 0, options);
                yd = -1;
            }
            else {
                distance = resolution * (offsetXY[1]) / 1000;
                point = turf.destination(point, distance, -180, options);
                if (offsetXY[1] == 0)
                    yd = 0;
                else
                    yd = 1;
            }

            let rect = getTextRectPoint(point, w, h, xd, yd);
            rect0 = rect[0];
            rect1 = rect[1];
            let exten = [rect0[0], rect1[1], rect1[0], rect0[1]];

            let features = displayLabelSource.getFeaturesInExtent(exten);
            if (features.length == 0) {

                let elOverFlow = checkElementOverflow(tname, exten, true);
                if (!elOverFlow) {
                    displayDebugPolygon("point", exten, "#00ff00", 'rgba(10,56,23,0)');
                    pos = transform(point.geometry.coordinates, 'EPSG:4326', 'EPSG:3857');
                    getIt = 1;
                    break;
                }
                else {
                    allOverFlowList.push([exten, point.geometry.coordinates, xd, yd]);
                    displayDebugPolygon("point", exten, "#efbf30", 'rgba(10,56,23,0)')
                }
            }
            else {
                displayDebugPolygon("point", exten, "#ff0000", 'rgba(20,39,123,0)')
            }

        }
        if (getIt == 0 && allOverFlowList.length > 0) {
            let b, temp;
            let i = 0;
            let elCount = []
            for (i = 0; i < allOverFlowList.length; i++) {
                let tCount = getElementCountInExten(tname, allOverFlowList[i][0],allOverFlowList[i][2],allOverFlowList[i][3]);
                // if(tname=="夏金变")
                // {
                //     console.log(tname,"elCount",tCount,allOverFlowList[i][2],allOverFlowList[i][3]);
                // }
                tCount += Math.abs(allOverFlowList[i][2]) + Math.abs(allOverFlowList[i][3]);
                //这样中间的4位置优先级会提高，因为中间伴xd,yd总有一个是0
                elCount.push(tCount);

            }

            for (i = 0; i < elCount.length; i++) {
                for (let j = 0; j < elCount.length; j++) {
                    if (elCount[j] > elCount[j + 1]) {
                        b = elCount[j];
                        elCount[j] = elCount[j + 1];
                        elCount[j + 1] = b;
                        temp = allOverFlowList[j];
                        allOverFlowList[j] = allOverFlowList[j + 1];
                        allOverFlowList[j + 1] = allOverFlowList;
                    }
                }
            }

            for (i = 0; i < allOverFlowList.length; i++) {

                let elOverFlow = checkElementOverflow("", allOverFlowList[i][0], false)
                if (!elOverFlow) {
                    try {
                        pos = transform(allOverFlowList[i][1], 'EPSG:4326', 'EPSG:3857');
                    }
                    catch (err) {
                        console.log(err.message);
                    }
                    getIt = 1;
                    break;
                }
            }
        }

        let olfeature = new Feature({
            geometry: new Point(pos), //几何信息
            name: tname,
            fixedFeature: dli.feature,
            labelLayer: true,
            layer: dli.layer
        });

        let textColor = getElementColorByGB("color",color)
        let trgba= window.common.hexToRgb(textColor,1);
        textColor =`rgba(${trgba.r},${trgba.g},${trgba.b},${trgba.alph*opacity}`

        let  fcolor = getElementColorByGB("labelfill","auto")
        let frgba= window.common.hexToRgb(fcolor,1);
        fcolor =`rgba(${frgba.r},${frgba.g},${frgba.b},${frgba.alph*opacity}`

        let  bcolor = getElementColorByGB('labelborder','auto')
        let brgba= window.common.hexToRgb(bcolor,1);
        bcolor =`rgba(${brgba.r},${brgba.g},${brgba.b},${brgba.alph*opacity}`



        olfeature.setStyle(() => {
            let st= new Style({
                text: new olText({
                    backgroundFill: new olFill({
                        color: fcolor
                    }),
                    backgroundStroke: new Stroke({
                        color: bcolor, //颜色
                        width: 1 //宽度
                    }),
                    // text: tname,
                    textAlign: "center",
                    rotateWithView: true,
                    overflow: true,
                    rotation: 0,
                    placement: "point",
                    font: fontInfo,
                    offsetY: 0,
                    offsetX: 0,
                    fill: new olFill({
                        color: 'black'//popup-color
                    }),
                    // stroke: new Stroke({
                    //     color: '#8d8d8d', //颜色
                    //     width: 0 //宽度
                    // }),      
                })

            });
            let rText = window.common.getStringListSegment(
                tname.split("\n"),
                fontSize,
                dli.font
              );
                    
            if (rText.length == 1) 
                st.getText().setText(rText[0]);
            else 
                st.getText().setText(rText);
            return st;
        }); //设置要素样式


        displayLabelSource.addFeature(olfeature);
    }

    console.log("drawPointDisplayLabel", "over");
}

function saveLineLabelInfo(ly, feature, subObj, tname) {
    lineLabelList.push({
        "name": tname,
        "layer": ly,
        "feature": feature,
        "style": subObj
    });

    return;
}

function drawLineDisplayLabel(curZoom) {
    if (!window.global.labelShow) {
        return
    }

    let resolution = window.global.map.getView().getResolution();
    let trigw_h = 3;
    let trigh = 8;
    let coors = [], pos, rawcoors;

    let m = map.getView().calculateExtent(map.getSize());

    // console.log("drawLineDisplayLabel start",lineLabelList.length);
    // for(let xx=0;xx<lineLabelList.length;xx++)
    // {
    //     let dli=lineLabelList[xx];
    //     let tname = dli.name;
    //     console.log(tname);
    // }
    for (let xx = 0; xx < lineLabelList.length; xx++) {

        let dli = lineLabelList[xx];
        let layer = dli.layer;
        let tname = dli.name;
        let feature = dli.feature;
        let geom = feature.getGeometry();
        let subObj = dli.style;
        let fontSize = subObj.text.fontSize;
        let canvas = document.createElement('canvas');
        let context = canvas.getContext('2d', { willReadFrequently: true });
        let x = 0;
        let y = 0;
        let wh = window.common.computeFontSize(tname, fontSize, subObj.text.font);
        let w = wh.width;

        let halfw = w / 2;
        let h = wh.height + 4;
        coors = [];
        // if(tname=="凤岩5832线")
        // {
        //     console.log(tname);
        // }
        // h+Math.floor(Math.random() * 10);
        // console.log(tname);
        let gtype = geom.getType()
        if (gtype == "MultiLineString") {
            rawcoors = window.common.sortLineCoordinates(geom.getLineStrings())[1];
        }
        else {
            rawcoors = geom.getCoordinates();
        }
        let ci = 0;
        if (rawcoors.length <= 4) {
            rawcoors = window.common.cutTracepoints(rawcoors);

        }

        for (let i = 0; i < rawcoors.length; i++) {
            if (rawcoors[i][0] < m[0] || rawcoors[i][0] >= m[2])
                continue;
            if (rawcoors[i][1] < m[1] || rawcoors[i][1] >= m[3])
                continue;
            coors[ci] = rawcoors[i];
            ci++;
        }



        // let m = map.getView().calculateExtent(map.getSize());
        // let mtl=transform([m[0],m[1]], 'EPSG:3857', 'EPSG:4326');
        // let mtr=transform([m[2],m[1]], 'EPSG:3857', 'EPSG:4326');
        // let mbl=transform([m[0],m[3]], 'EPSG:3857', 'EPSG:4326');
        // let mbr=transform([m[2],m[3]], 'EPSG:3857', 'EPSG:4326');

        // let mapCenter = getFeatureCenter(m);
        // let tLineList=[]
        // tLineList[0] = turf.lineString([mtl,mtr]);
        // tLineList[1] = turf.lineString([mtl,mbl]);
        // tLineList[2] = turf.lineString([mbr,mbl]);
        // tLineList[3] = turf.lineString([mbr,mtr]);

        // if(tname == "吴苍5833线" || tname == "吴岩5834线" )
        // {
        //     console.log(tname);
        // }
        if (coors.length == 0)
            continue;

        if (coors.length <= 4) {
            rawcoors = window.common.cutTracepoints(coors);
            coors = []
            ci = 0;
            for (let i = 0; i < rawcoors.length; i++) {
                if (rawcoors[i][0] < m[0] || rawcoors[i][0] >= m[2])
                    continue;
                if (rawcoors[i][1] < m[1] || rawcoors[i][1] >= m[3])
                    continue;
                coors[ci] = rawcoors[i];
                ci++;
            }

        }
        if (coors.length == 0)
            continue;
        if (coors.length == 1) {
            pos = coors[0];
        }
        else {
            let ha = parseInt(coors.length / 2);
            if (curZoom < 7) {
                if (ha == 0) {
                    pos = coors[ha];
                    var point1 = turf.point(transform(coors[0], 'EPSG:3857', 'EPSG:4326'));
                    var point2 = turf.point(transform(coors[1], 'EPSG:3857', 'EPSG:4326'));
                    var midpoint = turf.midpoint(point1, point2);
                    pos = transform(midpoint.geometry.coordinates, 'EPSG:4326', 'EPSG:3857');
                }
                else {
                    var point1, point2;
                    try {

                        point1 = turf.point(transform(coors[ha], 'EPSG:3857', 'EPSG:4326'));
                        point2 = turf.point(transform(coors[ha - 1], 'EPSG:3857', 'EPSG:4326'));

                    }
                    catch (err) {
                        console.log("****");
                    }

                    var midpoint = turf.midpoint(point1, point2);
                    pos = transform(midpoint.geometry.coordinates, 'EPSG:4326', 'EPSG:3857');
                }
            }
            else {
                //自动决定显示的位置 
                let direction = 0;

                let orgHa = ha;
                let orgPos = null;
                let rect0;
                let rect1;
                let nextMiddle = 0;
                while (1) {
                    // if(tname == "吴苍5833线" || tname == "吴岩5834线" )
                    // {
                    //     console.log(ha,curZoom);
                    // }
                    if (ha == 0) {
                        var point1 = turf.point(transform(coors[0], 'EPSG:3857', 'EPSG:4326'));
                        var point2 = turf.point(transform(coors[1], 'EPSG:3857', 'EPSG:4326'));
                        var midpoint = turf.midpoint(point1, point2);
                        x = nextMiddle;
                        while (x != 0) {
                            midpoint = turf.midpoint(midpoint, point2);
                            x--;
                        }
                        nextMiddle++;
                        pos = transform(midpoint.geometry.coordinates, 'EPSG:4326', 'EPSG:3857');

                    }
                    else {
                        var point1, point2;
                        try {

                            point1 = turf.point(transform(coors[ha], 'EPSG:3857', 'EPSG:4326'));
                            point2 = turf.point(transform(coors[ha - 1], 'EPSG:3857', 'EPSG:4326'));

                        }
                        catch (err) {
                            console.log("****");
                        }

                        var midpoint = turf.midpoint(point1, point2);
                        x = nextMiddle;
                        while (x != 0) {
                            midpoint = turf.midpoint(midpoint, point2);
                            x--;
                        }
                        nextMiddle++;
                        pos = transform(midpoint.geometry.coordinates, 'EPSG:4326', 'EPSG:3857');
                        if (orgPos == null)
                            orgPos = pos;
                    }


                    {

                        var point = turf.point(transform(pos, 'EPSG:3857', 'EPSG:4326'));
                        var distance = resolution * (w) / 2 / 1000;
                        var bearing = 90;
                        var options = { units: 'kilometers' };

                        var br = turf.destination(point, distance, bearing, options);
                        //跳到右下点
                        bearing = -90;
                        let bl = turf.destination(point, distance, bearing, options);
                        //跳到左下点
                        point = turf.point(bl.geometry.coordinates)
                        distance = resolution * (h + trigh) / 1000;
                        bearing = 0;

                        let tl = turf.destination(point, distance, bearing, options);
                        //重跳到左上点
                        rect0 = transform(tl.geometry.coordinates, 'EPSG:4326', 'EPSG:3857');
                        rect1 = transform(br.geometry.coordinates, 'EPSG:4326', 'EPSG:3857');
                        let exten = [rect0[0], rect1[1], rect1[0], rect0[1]];
                        let e;
                        //扩展区

                        e = (exten[3] - exten[1]) / 2;

                        exten[3] = exten[3] + e / 4;
                        exten[1] = exten[1] - e - e / 2 + 2;

                        e = (exten[2] - exten[0]) / 2;
                        exten[2] = exten[0] + e * 3;
                        exten[0] = exten[0] - e;
                        // /2是因为前面的运算时已经2倍了


                        let features = displayLabelSource.getFeaturesInExtent(exten);
                        if (features.length == 0) {

                            //                            console.log(tname,"is no confict");
                            if (!checkElementOverflow(tname, [rect0[0], rect1[1], rect1[0], rect0[1]], false)) {
                                // if(tname == "吴苍5833线" || tname == "吴岩5834线" )
                                //     console.log("location",ha);
                                displayDebugPolygon("line", exten, "#09a846", "rgba(11,12,3,0.01)");
                                break;
                            }
                            else {
                                pos = null;
                                displayDebugPolygon("line", exten, "#a97826", "rgba(11,12,3,0.01)");

                            }

                        }
                        else {
                            pos = null;
                            displayDebugPolygon("line", exten, "#f91800", "rgba(11,12,3,0.01)");
                        }

                        if (nextMiddle == 1) {
                            nextMiddle = 0;
                            if (direction == 0) {//先向上找
                                ha += 1;
                                if (ha >= coors.length) {
                                    direction = 1;
                                    ha = orgHa;
                                }
                            }
                            else {//找不到，再到另一个方向找
                                ha -= 1;
                                if (ha < 0) {
                                    // pos = orgPos;
                                    break;
                                }
                            }
                        }

                    }
                }
            }
        }

        if (pos != null) {
            let olfeature = new Feature({
                geometry: new Point(pos), //几何信息
                name: tname,
                fixedFeature: feature,
                labelLayer: true,
                layer: layer

            });
            // context.fillStyle = subObj.text.fill;

            let opacity =layer.opacity||1;
            // if (tname.startsWith("宾"))
            // {
            //     console.log(tname)
            // }
            // else{
            //     console.log(tname)
            // }
            let fcolor=getElementColorByGB("fill","auto")
            let rgba= window.common.hexToRgb(fcolor,1);
            context.fillStyle =`rgba(${rgba.r},${rgba.g},${rgba.b},${rgba.alph*opacity})`

            
            let scolor=getElementColorByGB("labelborder","auto")
            let srgba= window.common.hexToRgb(scolor,1);

            
            context.strokeStyle =`rgba(${srgba.r},${srgba.g},${srgba.b},${srgba.alph*opacity})`
            
            context.beginPath();
            context.moveTo(0, 0);
            context.lineTo(x, y + h);

            context.lineTo(x + halfw - trigw_h, y + h);
            context.lineTo(x + halfw, y + h + trigh);
            context.lineTo(x + halfw + trigw_h, y + h);

            context.lineTo(x + w, y + h);
            context.lineTo(x + w, y);
            context.lineTo(x, y);

            // context.shadowColor='rgba(0,0,0,0.2)';
            // context.shadowBlur=10;
            // context.shadowOffsetX=5;
            // context.shadowOffsety=5;
            context.closePath();
            context.fill();
            context.stroke();
            let textColor = getElementColorByGB("color",subObj.text.color)
            let trgba= window.common.hexToRgb(textColor,1);
            textColor =`rgba(${trgba.r},${trgba.g},${trgba.b},${trgba.alph*opacity})`

            olfeature.setStyle(() => {
                return new Style({
                    image: new olIcon({
                        img: canvas,
                        imgSize: [w, h + trigh],
                        anchor: [0.5, 1],
                        // declutterMode:"declutter"
                        // offsetX:-parseInt(w/2)-10,// parseInt(subObj.text.offsetX),
                        // offsetY:parseInt(h/2)-3,
                    }),
                    text: new olText({
                        text: tname,
                        textAlign: "center",
                        rotateWithView: true,
                        overflow: true,
                        rotation: 0,
                        placement: "point",
                        font: fontSize + "px " + subObj.text.font,
                        textBaseline: mapCfg.text.textBaseline, //文本基线
                        offsetY: -parseInt(trigh + h / 2),
                        fill: new olFill({
                            // color:textColor
                            color:'black'//line-popup
                        }),
                        // stroke: new Stroke({
                        //     color: '#8d8d8d', //颜色
                        //     width: 0 //宽度
                        // }),      
                    })
                })
            }); //设置要素样式
            displayLabelSource.addFeature(olfeature);
        }
    }
    // console.log("drawLineDisplayLabel over");

}



function getFeatureStyleInSubObj(layerStyle, subObj, feature,
    fclass, curZoom, objName, filterName, vectorFrom, jl, newStyle,opacity) {
    let featureStyles = []
    let flowStyle = null;
    let txtCurZoom = curZoom;
    let mStyle = null;
    let minZoom = subObj.minZoom;
    let minImageZoom = subObj.image.minZoom;
    let minTextZoom = subObj.text.minZoom;

    let fetProp;
    let geom = feature.getGeometry();
    let mOpacity=jl.opacity;
    if (opacity)
        mOpacity=opacity

    totalElementCount += 1;
    if (totalElementCount == 2000) {//日志打印一下，如果在地图没有操作时，频繁输出这句话，表明程序出现不停刷新的现象。
        // console.log("watch...", totalElementCount)
        totalElementCount = 0;
    }
    if (subObj.visible == 0) {
        lastReturn = null;
        return null;
    }

    fetProp = window.common.getFeatureProperties(feature);
    let trim = subObj.text.trim;
    let tname = objName;
    if (trim == "")
        tname = objName;
    else if(objName.endsWith(trim))
        tname = objName.substring(0, objName.length-trim.length);
    else
        tname = objName;
    let lineDash = subObj.lineDash
    let lineWidth=subObj.width
    let colorAdd=0
    if(jl.enhancedDisplay && parseInt(jl.enhancedDisplay)==1)
    {
        lineDash=[]
        lineWidth+=2;
        // colorAdd=15
        minZoom=curZoom;
        minImageZoom=curZoom+4;
        //注意这里的顺序
        curZoom+=5;
        txtCurZoom+=5;
    }
    if (jl.tempMinZoom != null) {
        //如果打开了临时显示，把zoom提到本层最小的zoom。
        if (jl.tempMinZoom <= jl.minZoom)
        {
            curZoom += jl.minZoom - jl.tempMinZoom;
        }
    }
    else if(vectorFrom=="fromShow")
    {
        curZoom = jl.minZoom;
    }
    let filterCurZoom=0;
    if(isAsiaFilting())
    {
        if (5 <= jl.minZoom)
        {
            curZoom += parseInt(jl.minZoom )- 5;
            filterCurZoom = parseInt(curZoom)+parseInt(jl.minZoom) - 3;
            txtCurZoom+= parseInt(jl.minZoom) -5;

        }
    }

    curZoom += subObj.zoomOffset;

    let autoMinZoom = 20;
    let vkeyWord = window.common.safeGetJsonKey(jl, "voltageFiled", mapCfg.field.voltageFiled);
    let vVal = window.common.safeGetJsonKey(fetProp, vkeyWord, '0');

    lastVoltageInfo = window.common.getVoltageInfo(vVal);

    let item = lastVoltageInfo;
    autoMinZoom = parseInt(item.minZoom);

    if (minZoom == "auto") {
        minZoom = autoMinZoom-jl.voltageUpperLevel;
    }
    else
        minZoom = parseInt(minZoom);
    
    if(vectorFrom=="fromShow")
    {
        txtCurZoom =jl.minZoom;
    }
    else if (minTextZoom == "auto") {
        minTextZoom = autoMinZoom;
        if (minTextZoom < minZoom)
            minTextZoom = minZoom;
        if (curZoom - jl.minZoom <= 6)
            //当前图层与最小图层超过6层，不用考虑offset的事情了。
            txtCurZoom += subObj.text.zoomOffset;

        // if(minTextZoom<=14)
        //     minTextZoom+=3;
    }

    if (minImageZoom == "auto") {
        minImageZoom = autoMinZoom -jl.voltageUpperLevel;
    }

    if (tname == "" || tname == null) {
        minZoom += subObj.unamezoomdelay;
        minTextZoom += subObj.unamezoomdelay;
    }

    // if(jl.tempMinZoom != null)
    // {
    //     if (curZoom < jl.tempMinZoom) 
    //     {
    //         lastReturn = null;
    //         return null;
    //     }

    // }
    // else 
    if (curZoom < minZoom && filterCurZoom < minZoom) {
        lastReturn = null;
        return null;
    }
    if (newStyle) {
        mStyle = new Style({
            fill: new olFill({
                color: "#efefef"
            }),
            stroke: new Stroke({
                color: '#8d8d8d', //颜色
                width: 0, //宽度
                lineCap: mapCfg.style.lineCap, //线帽样式
                //butt：末端添加平直边缘；round：末端添加圆形线帽；square：末端添加方形线帽；
                lineJoin: mapCfg.style.lineJoin, //线条连接处样式
                //bevel：创建斜角；round：创建圆角；square：创建尖角；
                // lineDash:[2,3,1,2]
            }),
            text: new olText({

                rotateWithView: true,
                overflow: true,
                rotation: 0,
                placement: "point",
                font: mapCfg.text.fontSize + "px " + mapCfg.text.font,
                textBaseline: mapCfg.text.textBaseline, //文本基线
                offsetX: parseInt(mapCfg.text.offsetX),
                fill: new olFill({
                    color: "#efefef"
                }),
                // stroke: new Stroke({
                //     color: '#8d8d8d', //颜色
                //     width: 0 //宽度
                // }),      
            })
        });

    }
    else {
        mStyle = featureStyle;
    }
    let fcolor = getFillColor(jl, layerStyle, subObj, fetProp);
    let rgba= window.common.hexToRgb(fcolor,1);
    let rgbaStr=`rgba(${rgba.r},${rgba.g},${rgba.b},${rgba.alph})`
    mStyle.getFill().setColor(rgbaStr);


    let gtype = geom.getType()
    let txtVisible = 1;
    let c = getStrokeColor(jl, layerStyle, subObj, fetProp);
    let crgba= window.common.hexToRgb(c,mOpacity);
    // let crgbaStr=`rgba(${(crgba.r+colorAdd)>255?255:(crgba.r+colorAdd)},${(crgba.g+colorAdd)>255?255:(crgba.g+colorAdd)},${(crgba.b+colorAdd)>255?255:(crgba.b+colorAdd)},${crgba.alph})`
    let crgbaStr=`rgba(${crgba.r},${crgba.g},${crgba.b},${crgba.alph})`
    let tStroke = mStyle.getStroke();
    let tid = window.common.safeGetJsonKey(fetProp, "id", "");


    if (gtype == "LineString" || gtype == "MultiLineString" || gtype == "Polygon" || gtype == "MultiPolygon") {
        let isReal = window.common.safeGetJsonKey(fetProp, "check_code", '1');
        if (isReal == "0") {
            tStroke.setLineDash([5, 5]);
        }
        else {
            tStroke.setLineDash(lineDash);
        }
        tStroke.setColor(crgbaStr);

        // let w = parseInt(parseFloat(1 + subObj.lineScale * (curZoom - minZoom)) * subObj.width);
        tStroke.setWidth(lineWidth);
        tStroke.setLineCap(subObj.lineCap);
        tStroke.setLineJoin(subObj.lineJoin);

    }


  
    
    if (jl.type == "geoJson" && jl.name != "supply_graph")
        tname = maskName(tname);

    let tobj = mStyle.getText();
    if (txtCurZoom < minTextZoom || subObj.text.visible == 0 || tname == "" || tname == null) {
        tobj.setText("");
        // if(curZoom<minTextZoom || subObj.text.visible==0)
        //     mStyle.getText().getStroke().setWidth(0);
        // else
        //     mStyle.getText().getStroke().setWidth(1);
        mStyle.setImage(null);

    }
    else {

        if (gtype == "MultiLineString" || gtype == "LineString" ||
            ((gtype == "Point" || gtype == "MultiPoint" || gtype == "Polygon" || gtype == "MultiPolygon") && jl.displayByLabel)) {
            txtVisible = checkIdRepeat(tname, jl, fetProp)
        }

        if (!txtVisible) {
            tobj.setText("");
        }
        else {
            
            let textScale=subObj.text.scaleStep;
            if (jl.displayByLabel) {
                if (gtype == "LineString" || gtype == "MultiLineString") {
                    tobj.setText("");
                    saveLineLabelInfo(jl, feature, subObj, tname);
                }
                else if ((gtype == "Point" || gtype == "Polygon" || gtype == "MultiPolygon" || gtype == "MultiPoint")) {
                    tobj.setText("");
                    savePointLabelInfo(jl, tid,curZoom, subObj, tname, feature, textScale, minTextZoom);
                }
            }
            else {
                let lstep = 4;
                if (gtype == "LineString" || gtype == "MultiLineString")
                    lstep = 1;
                let x = parseInt(subObj.text.offsetX);
                if (x > 0)
                    x += textScale * 32;
                else if (x < 0)
                    x -= textScale * 32;

                let y = parseInt(subObj.text.offsetY);
                if (y > 0)
                    y += textScale * 12 + subObj.text.fontSize / 2;
                else if (y < 0)
                    y -= textScale * 12 + subObj.text.fontSize / 2;

                tobj.setText(tname);
                tobj.getFill().setColor(getElementColorByGB("color",subObj.text.color));
                // tobj.getStroke().setColor(subObj.text.bordercolor);
                // tobj.getStroke().setWidth(subObj.text.width);
                tobj.setOffsetX(parseInt(x));
                tobj.setOffsetY(parseInt(y));

                if (gtype == "LineString" || gtype == "MultiLineString") {
                    tobj.setPlacement("line");
                } else
                    tobj.setPlacement("point");

                let fontSize = parseInt(subObj.text.fontSize + (curZoom - minTextZoom));
                tobj.setFont(fontSize + "px " + subObj.text.font);

            }
        }
    }
    if ((curZoom < minImageZoom  && filterCurZoom<minImageZoom )|| subObj.image.visible == 0 || (gtype != "Point" && gtype != "MultiPoint")) {
        mStyle.setImage(null);

    }
    else {
        let scale = 0;
        if( typeof subObj.image.scale === 'number')
            scale = subObj.image.scale
        else
        {
             scale = parseFloat(window.common.safeGetJsonKey(fetProp, subObj.image.scale, mapCfg.image.scale));
        }
        if (subObj.image.scaleStep > 0)
        {
            if(filterCurZoom>0)
                scale = parseFloat(scale + subObj.image.scaleStep * (filterCurZoom - minImageZoom));
            else
                scale = parseFloat(scale + subObj.image.scaleStep * (curZoom - minImageZoom));
        }
       
        if (scale >= 1.5)
            scale = 1.5;
        else if (scale <= 0.25)
            scale = 0.25;
    
        let rotation = 0;
        if( typeof subObj.image.rotation === 'number')
            rotation = -subObj.image.rotation
        else
        {
            rotation = -parseFloat(window.common.safeGetJsonKey(fetProp, subObj.image.rotation, 0));
        }
    
        
        rotation = rotation * Math.PI / 180;    //计算出弧度
        
        // let icon = drawPointImage(curZoom, subObj, tname, geom, scale<0.5?0.5:scale, fclass);
        let icon = drawPointImage(feature,subObj,curZoom, tname, geom, scale, rotation,fclass,mOpacity);
        mStyle.setImage(icon);
    }


    lastReturn = mStyle;


    if (flowStyle == null)
    {
        if (gtype == "LineString" || gtype == "MultiLineString")
        {
            tStroke=mStyle.getStroke();
            let cc=tStroke.getColor()
            let lwidth=tStroke.getWidth()
            let rgb = window.common.hexToRgb(cc,mOpacity);
            flowStyle= new Style({
             
                stroke: new Stroke({
                    color: "rgba("+rgb.r+","+rgb.b+","+rgb.g+","+rgb.alph*0.1+")", //颜色
                    width: lwidth+4, //宽度
                    lineCap: mapCfg.style.lineCap, //线帽样式
                    //butt：末端添加平直边缘；round：末端添加圆形线帽；square：末端添加方形线帽；
                    lineJoin: mapCfg.style.lineJoin, //线条连接处样式
                    lineDash:tStroke.getLineDash()
                    //bevel：创建斜角；round：创建圆角；square：创建尖角；
                    // lineDash:[2,3,1,2]
                })
            });
            if(subObj["overlayColor"])
            {
                let flowStyle2= new Style({
                    stroke: new Stroke({
                        color: subObj["overlayColor"], //颜色
                        width: subObj["overlayWidth"]?parseInt(subObj["overlayWidth"]):lwidth, //宽度
                        lineCap: subObj.lineCap, //线帽样式
                        //butt：末端添加平直边缘；round：末端添加圆形线帽；square：末端添加方形线帽；
                        lineJoin: subObj.plineJoin, //线条连接处样式
                        //bevel：创建斜角；round：创建圆角；square：创建尖角；
                        lineDash:subObj.overlayDash
                    })
                });
                // featureStyles.push(flowStyle);
                featureStyles.push(mStyle);
                featureStyles.push(flowStyle2); 
                return featureStyles;
            }
            else if(subObj.lineFlash==1)
            {
                let flowStyle2= new Style({
                    stroke: new Stroke({
                        color: "rgba("+rgb.r+","+rgb.b+","+rgb.g+","+rgb.alph*0.5+")", //颜色
                        width: lwidth+2, //宽度
                        lineCap: subObj.lineCap, //线帽样式
                        //butt：末端添加平直边缘；round：末端添加圆形线帽；square：末端添加方形线帽；
                        lineJoin: subObj.lineJoin, //线条连接处样式
                        lineDash:tStroke.getLineDash()
                        //bevel：创建斜角；round：创建圆角；square：创建尖角；
                        // lineDash:[2,3,1,2]
                    })
                });
                // featureStyles.push(flowStyle);
                featureStyles.push(flowStyle2);
                featureStyles.push(mStyle);
                return featureStyles;
            }
            else
            {
                return mStyle;
            }

        }
        else 
            return mStyle;
    }
    else {
        featureStyles.push(mStyle);
        featureStyles.push(flowStyle);
        return featureStyles;

    }
}


function getAisaFilterlayer(filterGroupName) {
    let l=[]
    for (var i = 0; i < layerCfg.length; i++) {
        let jl = layerCfg[i];
        if (jl.asiaFilterGroup == filterGroupName) {
            l.push(jl);
        }
    }
    return l;
}

function getLayerBygeoName(geoName) {
    for (var i = 0; i < layerCfg.length; i++) {
        let jl = layerCfg[i];
        if (jl.geolayerName == geoName) {

            return jl;
        }
    }
    return null;
}
function getLayerByName(layerName, startPos) {
    if(!startPos){
        startPos = 0;
    }
    for (var i = startPos; i < layerCfg.length; i++) {
        let jl = layerCfg[i];
        if (jl.name == layerName) {

            return [jl, i];
        }
    }
    return [null, i];
}

function getLayerCfgBylayer(ly) {
    for (var i = 0; i < layerCfg.length; i++) {
        let jl = layerCfg[i];
        if (jl.ol == ly) {

            return jl;
        }
    }
    return null;
}
function getLayerCfgBylayerTower() {
    for (var i = 0; i < layerCfg.length; i++) {
        let jl = layerCfg[i];
        if (jl.name == "dev_tower") {

            return jl;
        }
    }
    return null;
}

function getLayerCfgByOLid(ol_uid) {
    for (var i = 0; i < layerCfg.length; i++) {
        let jl = layerCfg[i];
        if (jl.ol == null)
            continue;
        if (jl.ol.ol_uid == ol_uid) {

            return jl;
        }
    }
    return null;
}



function checkAllLayerLoaed() {
    for (var i = 0; i < layerCfg.length; i++) {
        let jl = layerCfg[i];
        if (jl.ol == null)
            continue;
        if (jl.loadRenderStep) {

            return false;
        }
    }
    return true;
}


function getLayerStyleCfg(feature, vectorFrom) {
    let fetProp = null;
    fetProp = window.common.getFeatureProperties(feature);

    if (lastLayerName != fetProp.layer ||
        lastLayerStyleObj == null) {
        lastLayerStyleObj = null;
        lastLayerName = "";
        let jl = getLayerBygeoName(fetProp.layer);
        if (jl != null) {
            lastLayerName = fetProp.layer;
            lastLayerStyleObj = jl.style;
            lastLayerCfg = jl;
        }
    }
}



function loadFilterSqlXml(jl, styleObj, sfilter, keyword, curZoom) {

    let fkey = "";
    let valCollection = [];
    let fieldXmlList = [];
    let haveNextFilter = window.common.safeGetJsonKey(sfilter, "continue", 0);
    let filter = {};
    let teq = null;
    for (let f in sfilter) {
        filter[f] = sfilter[f];
    }
    filter.default = [];

    for (var key in filter) {
        fkey = filter[key];
        valCollection = [];
        if (key == "continue" || key == "isFilter" || key == "keyword")
            continue;
        if (fkey.length == 0) {
            valCollection = [];
        }
        else for (var x = 0; x < fkey.length; x++) {
            valCollection.push(fkey[x]);
        }
        let s = window.common.safeGetJsonKey(styleObj, key, null);
        if (s == null)
            haveNextFilter = 0;
        if (window.common.safeGetJsonKey(s, "isFilter", 0) == 0)
            haveNextFilter = 0;
        let nextKey = window.common.safeGetJsonKey(s, "keyword", "");
        if (nextKey == "")
            haveNextFilter = 0;

        if (haveNextFilter == 1) {

            let nextFilterStr = loadFilterSqlStr(jl, styleObj, s, nextKey, curZoom);

            if (fieldStr != "") {
                fieldStr += ' or ';
            }
            if (nextFilterStr != "") {
                let curXmlList = []
                for (var x = 0; x < valCollection.length; x++) {
                    teq = new EqualTo(keyword, valCollection[x]);
                    teq.matchCase = false;
                    curXmlList.push(teq);
                }


                fieldXmlList.push(new And(new Or(...curXmlList), new Or(...nextFilterStr)));

            }
            else {
                for (var x = 0; x < valCollection.length; x++) {
                    teq = new EqualTo(keyword, valCollection[x]);
                    teq.matchCase = false;
                    fieldXmlList.push(teq);
                }
            }

        }

        else {

            let minZoom = window.common.safeGetJsonKey(s, "minZoom", 20);
            let maxZoom = window.common.safeGetJsonKey(s, "maxZoom", 20);
            if (minZoom == "auto") {
                valCollection = valCollection.concat(window.common.getVoltageFilter(curZoom+jl.voltageUpperLevel));
                let vkeyWord = window.common.safeGetJsonKey(jl, "voltageFiled", mapCfg.field.voltageFiled);
                if (curZoom <= maxZoom) {
                    for (var x = 0; x < valCollection.length; x++) {
                        teq = new EqualTo(vkeyWord, valCollection[x]);
                        teq.matchCase = false;
                        fieldXmlList.push(teq);
                    }
                }
            }
            else {
                minZoom = parseInt(minZoom);
                if (curZoom >= minZoom && curZoom <= maxZoom ) {
                    for (var x = 0; x < valCollection.length; x++) {
                        teq = new EqualTo(keyword, valCollection[x]);
                        teq.matchCase = false;
                        fieldXmlList.push(teq);
                    }
                }
            }
        }

    }
    return fieldXmlList;

}

function loadFilterSqlStr(jl, styleObj, sfilter, keyword, curZoom) {

    let fkey = "";
    let valCollection = "";
    let fieldStr = "";
    let haveNextFilter = window.common.safeGetJsonKey(sfilter, "continue", 0);
    let filter = {};
    for (let f in sfilter) {
        filter[f] = sfilter[f];
    }
    filter.default = [];

    for (var key in filter) {
        fkey = filter[key];
        valCollection = "";
        if (key == "continue" || key == "isFilter" || key == "keyword")
            continue;
        if (fkey.length == 0) {
            valCollection = "";
        }
        else for (var x = 0; x < fkey.length; x++) {
            if (valCollection != "")
                valCollection += ","
            valCollection += "'" + fkey[x] + "'";

        }
        let s = window.common.safeGetJsonKey(styleObj, key, null);
        if (s == null)
            haveNextFilter = 0;
        if (window.common.safeGetJsonKey(s, "isFilter", 0) == 0)
            haveNextFilter = 0;
        let nextKey = window.common.safeGetJsonKey(s, "keyword", "");
        if (nextKey == "")
            haveNextFilter = 0;

        if (haveNextFilter == 1) {

            let nextFilterStr = loadFilterSqlStr(jl, styleObj, s, nextKey, curZoom);

            if (fieldStr != "") {
                fieldStr += ' or ';
            }
            if (nextFilterStr != "")
                fieldStr += "  (" + keyword + " in (" + valCollection + ") and (" + nextFilterStr + ")) ";
            else
                fieldStr += "  " + keyword + " in (" + valCollection + ")  ";

            // console.log("get sql filter [", key, "]", fieldStr);

        }

        else {

            let minZoom = window.common.safeGetJsonKey(s, "minZoom", 20);
            let maxZoom = window.common.safeGetJsonKey(s, "maxZoom", 20);
            if (minZoom == "auto") {
                valCollection = window.common.getVoltageFilterStr(curZoom+jl.voltageUpperLevel, valCollection);
                let vkeyWord = window.common.safeGetJsonKey(jl, "voltageFiled", mapCfg.field.voltageFiled);
                if (valCollection != "" && curZoom <= maxZoom) {
                    if (fieldStr != "")
                        fieldStr += ' or ';
                    fieldStr += vkeyWord + " in (" + valCollection + ") ";
                }
            }
            else
                minZoom = parseInt(minZoom);
            if (valCollection != "" && curZoom >= minZoom && curZoom <= maxZoom) {
                if (fieldStr != "")
                    fieldStr += ' or ';
                fieldStr += keyword + " in (" + valCollection + ") ";
                // console.log("get sql filter [", key, "]", fieldStr);
            }
        }

    }
    return fieldStr;


}

function combineCQLFilterXml(layer) {
    let styleObj = layer.style;
    if (styleObj == null)
        return "";
    if (layer.tempVisible == 1)
        return "";
    if(isAsiaFilting() ||(layer.skipVoltageCtrl && parseInt(layer.skipVoltageCtrl)==1))
    {
        return ""
    }
    let curZoom = window.common.getMapZoomInt();
    let filter = window.common.safeGetJsonKey(styleObj, "filter", []);
    return loadFilterSqlXml(layer, styleObj, filter, window.common.safeGetJsonKey(layer, "classNameField", ""), curZoom);
}

function combineCQLFilter(layer) {
    let styleObj = layer.style;
    if (styleObj == null)
        return "";
    if (layer.tempVisible == 1)
        return "";
    if(isAsiaFilting() ||(layer.skipVoltageCtrl && parseInt(layer.skipVoltageCtrl)==1))
    {
        return ""
    }
    let curZoom = window.common.getMapZoomInt();
    // if(clipLayer!=null)
    // {
    //     clipLayer.getSource().forEachFeature(feature => {
    //         // vectorContext.drawFeature(feature, clipStyle);
    //         console.log(feature.getGeometry().getCoordinates());
    //     });
    // }




    let filter = window.common.safeGetJsonKey(styleObj, "filter", []);

    let filterStr = loadFilterSqlStr(layer, styleObj, filter, window.common.safeGetJsonKey(layer, "classNameField", ""), curZoom);

    // if(cqlPolygonFilterStr!="")
    // {
    //     if(filterStr!="")
    //         filterStr+="and ("+cqlPolygonFilterStr+")"
    //     else
    //     filterStr=cqlPolygonFilterStr;
    // }

    if (filterStr == "")
        return "";

    //console.log(curZoom, filterStr);
    return "&CQL_FILTER=" + encodeURIComponent(filterStr);

    //    // let polyGon="ST_Polygon('LINESTRING(119.67099569141868, 30.0961433292441 119.67099569141868, 30.012462099460308 119.76767558008434, 29.966788062901614 119.93906236588957, 29.99723961024587 119.99619107097392, 30.088538841198996 119.89951151758437, 30.187351173508077 119.72812473177912, 30.17975371046566 119.67099569141868, 30.0961433292441)'::geometry, 4326)";

    //     // let polyGon="Polygon('LINESTRING(119.67099569141868, 30.0961433292441 119.67099569141868, 30.012462099460308 119.76767558008434, 29.966788062901614 119.93906236588957, 29.99723961024587 119.99619107097392, 30.088538841198996 119.89951151758437, 30.187351173508077 119.72812473177912, 30.17975371046566 119.67099569141868, 30.0961433292441)'::geometry, 4326)";
    //     let polyGon ="POLYGON(("+
    //         '119.65781263411048 30.122754140488922,'+
    //         '119.38095703125005 29.684667672632045,'+
    //         '120.49716803580526 29.90966578473254,'+
    //         '119.65781263411048 30.122754140488922'+

    //     "))";




    //     filterStr=" INTERSECTS(geom, "+polyGon+")";
    //     filterStr+=" and voltagelevel in ('10kV') "

    //    // let filterStr="name='电20~门架'";
    // //    filterStr=
    // //    '<Filter xmlns="http://www.opengis.net/ogc" xmlns:gml="http://www.opengis.net/gml">'+
    // //    '<Intersects><PropertyName>geom</PropertyName><gml:Polygon>'+
    // //        '<gml:outerBoundaryIs> ' +
    // //            '<gml:LinearRing>'+
    // //            '<gml:coordinates>119.67099569141868, 30.0961433292441 119.67099569141868, 30.012462099460308 119.76767558008434, 29.966788062901614 119.93906236588957, 29.99723961024587 119.99619107097392, 30.088538841198996 119.89951151758437, 30.187351173508077 119.72812473177912, 30.17975371046566</gml:coordinates>'+
    // //            '</gml:LinearRing>'+
    // //        '</gml:outerBoundaryIs>'+
    // //    '</gml:Polygon></Intersects></Filter>';

    //     //let filterStr="name='电20~门架'";




    //     var curZoom = window.common.getMapZoomInt();

    // return "CQL_FILTER="+encodeURIComponent(filterStr);
}



//http://10.20.1.225:8080/geoserver/test/wms?service=WMS&version=1.1.0&request=GetMap&layers=test:dwyzt_pwfeederlinepsr_b&format=geojson&srs=EPSG:3857&bbox=12844258.094399558,3119542.2974373642,13905815.543224087,3698017.727499578&width=1531&height=764&CQL_FILTER=INTERSECTS(geom%2C%20POLYGON((-119.6709%2030.0961%2C-119.6709%2030.0124%20%2C-119.767%2029.9667%2C-119.939%2029.9972%20%2C-119.9961%2030.0885%2C-119.89951151758437%2030.1873%2C-119.7281%2030.1797%2C%20-119.6709%20%2030.0961)))



//0-nothing
//1-place somethine
//2-draw a Circle
//3-popup

///==================================
//解决百度 的 偏移问题





export function createMap(itemId) {
    window.global.map = null;
    let t = window.common.safeGetJsonKey(mapCfg, "textfield", "");
    mapCenterXY = [parseFloat(mapCfg.centerX), parseFloat(mapCfg.centerY)];
    var c = mapCenterXY;
    let curZoom = parseFloat(mapCfg.defaultZoom);
    window.global.lastZoom = curZoom;
    map = new Map({
        target: itemId,
        // interactions: interaction.defaults().extend([      
        //     new interaction.DragRotateAndZoom()
        // ]),
        view: new View({
            center: fromLonLat(c),
            zoom: curZoom,
            maxZoom: parseInt(mapCfg.maxZoom),
            minZoom: parseInt(mapCfg.minZoom),

        }),
        // interactions: new interaction.defaults({
        //     doubleClickZoom:false
        // }),
        layers: [
            //KMLVectorLayer
            // new Tile({
            //     source: new source.XYZ({
            //     //   url: "https://wprd0{1-4}.is.autonavi.com/appmaptile?lang=zh_cn&size=1&style=7&x={x}&y={y}&z={z}",
            //     url: "https://webst01.is.autonavi.com/appmaptile?style=6&x={x}&y={y}&z={z}"    
            // }),
            //   }),

        ],
        loadTilesWhileAnimating: true,

    });
    const dbclickInteraction=map.getInteractions().getArray().find(interaction=>{
        return interaction instanceof  DoubleClickZoom
    })
    map.removeInteraction(dbclickInteraction)
    window.global.map = map;



    let ly = null;
    let layerLen = layerCfg.length;


    for (let i = 0; i < layerLen; i++) {

        let jl = layerCfg[i];
        jl.index = i;
        layerCfg[i].ol = null;
        jl.textfield = window.common.safeGetJsonKey(jl, "textfield", mapCfg.text.textfield);
        jl.idfield = window.common.safeGetJsonKey(jl, "idfield", mapCfg.text.idfield);
        jl.classNameField = window.common.safeGetJsonKey(jl, "classNameField", mapCfg.field.classNameField);
        jl.voltageFiled = window.common.safeGetJsonKey(jl, "voltageFiled", mapCfg.field.voltageFiled);

        jl.tempVisible = null;

        jl.rightMenu = parseInt(window.common.safeGetJsonKey(jl, "rightMenu", "1")) == 1 ? true : false;
        jl.leftMenu = parseInt(window.common.safeGetJsonKey(jl, "leftMenu", "1")) == 1 ? true : false;
        jl.epsg = window.common.safeGetJsonKey(jl, "epsg", "900913");

        jl.declutterMode = parseInt(window.common.safeGetJsonKey(jl, "declutterMode", "1")) == 1 ? true : false;
        jl.displayByLabel = parseInt(window.common.safeGetJsonKey(jl, "displayByLabel", 0)) == 1 ? true : false;
        jl.syncWeatherData = parseInt(window.common.safeGetJsonKey(jl, "syncWeatherData", 0)) == 1 ? true : false;
        jl.asiaFilterGroup = window.common.safeGetJsonKey(jl, "asiaFilterGroup", "")
        



        let online = window.common.safeGetJsonKey(jl, "online", "0");
        if (online == "0")
            continue;
        let geoName = jl.geolayerName.split(",");
        for (let g = 0; g < geoName.length; g++) {
            if (geoName[g] == "")
                continue;
            if (g != 0) {
                let curLen = layerCfg.length;
                layerCfg[curLen] = {};
                for (let key in jl) {
                    layerCfg[curLen][key] = jl[key];
                }
                jl = layerCfg[curLen];

                jl.index = curLen;
            }
            jl.geolayerName = geoName[g];
            jl.opacity = parseFloat(window.common.safeGetJsonKey(jl, "opacity", mapCfg.opacity));
            ly = createMapLayer(jl.name, jl);
            if (ly == null)
                continue;
            jl.loadRenderStep = 0;
            //0-idle load and render over //1-loading //2 rendering
            let minZoom = parseInt(window.common.safeGetJsonKey(jl, "minZoom", 14));
            let maxZoom = parseInt(window.common.safeGetJsonKey(jl, "maxZoom", 20));
            let isVisible = parseInt(window.common.safeGetJsonKey(jl, "visible", 1));
            jl["voltageUpperLevel"]=0;

            jl["pointerMove"] = window.common.safeGetJsonKey(jl, "pointerMove", "1") == "1" ? true : false;


            map.addLayer(ly);
            if (curZoom >= minZoom && curZoom <= maxZoom && isVisible) {//1 means temp force display
                //null do nothing

                ly.setVisible(true);

            }
            else {
                ly.setVisible(false);
            }
            layerCfg[i].ol = ly;
            if (g == 0) {
                let s = window.common.safeGetJsonKey(jl, "style", "");
                if (s != "") {
                    let jlStyle = eval("layerStyleCfg" + "." + s);
                    jl.style = completeLayerStyle(jlStyle, jl);
                }
                else
                    jl.style = null;
            }
            layerCfg[jl.index] = jl;
            //            addClipMap(ly);
        }
    }




    // createdisplayLineTextLayer();
    createDisplayLabelLayer();
    createdisplayLineConnectLayer();
    window.mapOperator.addClickEvent();
    window.mapOperator.dragPoints();
    // window.mapOperator.pointClick();
    window.mapOperator.pointDown();
    window.mapOperator.pointUp();
    // window.mapOperator.addRightClickEvent();
    window.mapOperator.addEquemtTree();
    window.mapOperator.addDispayLinePathLayer();
    window.mapOperator.createElementMarkAniLayer();
    try{
        window.mapHeatLine.createHeatlineLayer();
        if(window.global.applicationScene == 'asia')
        {
            let layerList = getHeatLineLayer();
            window.mapHeatLine.openHeatLine(layerList, "asiaway");
        }
    }
    catch(e)
    {
        console.log(e)
    }
    window.mapWeather.createWeatherTipLayer();
    createSelectedDisplayLayer();
    createbreakDownDisplayLayer();

    addPointerMoveEvent();
    addResoultChangedEvent();
    addZoomEvent();
    addLoadEvent();
    addScaleLint();
    // addZoomSlider();
    // addRotate();
    // addFullScreen();
    //addMousePoint("mousePosition");
    commVectorSource = new VectorSource({
        url: "",
        projection: "3857",
        format: new GeoJSON()
    });

    // setTimeout(function () {
    //     refreshAllGeoLayer();
    //   },500)
    getMapInitExten();

 


    return map;
}

function flytoExtenLocation(exten4326,zoom){
    map.getView().animate({
        center:transform(exten4326, 'EPSG:4326', 'EPSG:3857'),
        duration:1200,
        zoom:zoom
      })

}
function flytoAsiaExtenLocation(center4326,zoom,exten2358,animate){
    if(animate)
    {
        map.getView().animate({
        center:transform(center4326, 'EPSG:4326', 'EPSG:3857'),
        duration:1200,
        zoom:zoom
      })
    }
    else
    {

        map.getView().fit(exten2358, {
            constrainResolution: true,
            nearest: true
        })
    }

}


function getMapInitExten()
{

    setTimeout(() => {
        initExten=map.getView().calculateExtent(map.getSize());    
    }, 1000);
    
}


function createbreakDownDisplayLayer() {
    breakDownSource = new Vector();
    breakDownLayer = new VectorLayer({
        url: "",
        features: [],
        title: "breakDownLayer_inner",
        source: breakDownSource,
        style: function (feature) {

            let curZoom = window.common.getMapZoomInt(); //获取当前地图的缩放级别
            let gType = feature.getGeometry().getType();

            // if (gType == "LineString" || gType == "MultiLineString") {
            //     selectedStyle.getText().setPlacement("line");
            // } else
            //     selectedStyle.getText().setPlacement.setPlacement("point");     
            //selectedStyle.getText().setText(feature.getProperties().name);


            
            selectedStyle.setImage(new olCircle({
                radius: parseInt(layerStyleCfg.breakdown_style.radius) + curZoom - 8,
                fill: new olFill({
                    color: layerStyleCfg.breakdown_style.fill,
                }),
                stroke: new Stroke({
                    width: 6,
                    color: layerStyleCfg.breakdown_style.color,
                }),
            }));
            return breakdownStyle;
        },
    });



    breakDownLayer.setZIndex(200);
    map.addLayer(breakDownLayer);


}

function createSelectedDisplayLayer() {
    displaySelectedSource = new Vector();
    displaySelectedLayer = new VectorLayer({
        url: "",
        features: [],
        title: "displaySelectLayer_inner",
        source: displaySelectedSource,
        style: function (feature) {

            let curZoom = window.common.getMapZoomInt(); //获取当前地图的缩放级别
            let gType = feature.getGeometry().getType();

            // if (gType == "LineString" || gType == "MultiLineString") {
            //     selectedStyle.getText().setPlacement("line");
            // } else
            //     selectedStyle.getText().setPlacement.setPlacement("point");     
            //selectedStyle.getText().setText(feature.getProperties().name);
            if (gType == "LineString" || gType == "MultiLineString") {
                selectedStyle.setImage(null);
            }
            else
            {
            selectedStyle.setImage(new olCircle({
                radius: parseInt(layerStyleCfg.selected_style.radius) + curZoom - 8,
                fill: new olFill({
                    color: layerStyleCfg.selected_style.fill,
                }),
                stroke: new Stroke({
                    width: layerStyleCfg.selected_style.width,
                    color: layerStyleCfg.selected_style.color,
                }),
            }));
            }
            return selectedStyle;
        },
    });
    displaySelectedLayer.setZIndex(3);
    map.addLayer(displaySelectedLayer);

    selectOverlay = new Overlay({
        element: document.getElementById("feature_tip"),
        positioning: "center-center",
        offset: [5, 5],
        autoPan: true,
        className: "", //必須置空，不然overlay click事件不行
        autoPanMargin: 200,
        autoPanAnimation: {
            duration: 250, //当Popup超出地图边界时，为了Popup全部可见，地图移动的速度.
        }
    });

    map.addOverlay(selectOverlay);
    // let  measOverlay = new Overlay({
    //         element: document.getElementById("qzbdFeature_tip"),
    //         positioning: "center-center",
    //         offset: [5, 5],
    //         autoPan: true,
    //         className: "", //必須置空，不然overlay click事件不行
    //         autoPanMargin: 200,
    //         autoPanAnimation: {
    //             duration: 250, //当Popup超出地图边界时，为了Popup全部可见，地图移动的速度.
    //         }
    //     });

    // map.addOverlay(measOverlay);
}
function createdisplayLineConnectLayer() {
    displayLineConnectSource = new Vector();
    displayLineConnectLayer = new VectorLayer({
        features: [],
        url: "",
        title: "displaySubstationTextLayer_inner",
        source: displayLineConnectSource,
        declutter: false
    });
    let t = map.getLayers().getLength();
    displayLineConnectLayer.setZIndex(parseInt(mapCfg.connectLineLayerIndex));
    map.addLayer(displayLineConnectLayer);

}


function createDisplayLabelLayer() {
    displayLabelSource = new Vector();
    displayLabelLayer = new VectorLayer({
        title: "displayLabelLayer_inner",
        source: displayLabelSource,
        declutter: false
    });
    let t = map.getLayers().getLength();
    displayLabelLayer.setZIndex(t + 1);
    map.addLayer(displayLabelLayer);
    window.global.displayLabelLayer = displayLabelLayer;
}

// function createdisplayLineTextLayer() {
//     displayLineTextSource = new Vector();

//     displayLineTextLayer = new VectorLayer({
//         url: "",
//         title: "displayLineTextLayer_inner",
//         source: displayLineTextSource,
//         declutter: true
//     });

//     let t = map.getLayers().getLength();
//     displayLineTextLayer.setZIndex(t + 1);
//     map.addLayer(displayLineTextLayer);

// }

function setTempFilter(vFiltre, pFilter, sFilter) {
    let mapRect = map.getView().calculateExtent(map.getSize());
    voltageLevelFilter = vFiltre;
    plantTypeFilter = pFilter;
    subStationTypeFilter = sFilter;
    // displayLineTextSource.clear(true);
    displayLineConnectSource.clear(true);
    displayLabelSource.clear(true);
    // window.mapHeatLine.hiddenHeatLine();
    refreshAllGeoLayer();

}

function getFeaturesInExtentbygeoJson(index, l, cbFunc) {
let filterStr = combineCQLFilter(l);
    const projCode = "EPSG:3857";
    const width = parseInt(document.documentElement.clientWidth);
    const height = parseInt(document.documentElement.clientHeight);
    let extent = window.global.map.getView().calculateExtent(window.global.map.getSize());

    let url = mapCfg.geoJsonUrl + "/" + mapCfg.geoWorkSpace + "/wms?service=WMS&version=1.1.0&request=GetMap&layers=" +
        mapCfg.geoWorkSpace + ":" + l.geolayerName + "&format=geojson";

    url = url + '&srs=' + projCode + '&' +
        'bbox=' + extent.join(',') + '&width=' + width + "&height=" + height + filterStr;
    const xhr = new XMLHttpRequest()

    xhr.index = index;

    xhr.cbFunc = cbFunc;
    xhr.open('GET', url);
    const onError = function () {
        xhr.cbFunc(xhr.index, 'fail', null);
    }
    xhr.onerror = onError;
    xhr.onload = function () {
        if (xhr.status == 200) {
            const features = commVectorSource.getFormat().readFeatures(xhr.responseText);
            xhr.cbFunc(xhr.index, 'success', features);


        } else {

            xhr.cbFunc(xhr.index, 'fail', null);
            onError();
        }
    }
    xhr.send(

    );

}



// var clipStyle = null;

// var clipLayerSource = null;
// var clipLayer = null;
// var clipPolygons = null;
var clipFeatures = [];

function createClipLayer(cityNameList) {


    if (cityNameList.length == 0) {
        removeClipLayer();
        return;
    }
    let url = mapCfg.wfsUrl + mapCfg.geoWorkSpace + ":" + "city_zj" + "&outputFormat=application/json&maxFeatures=5000";
    // let filterStr = "&CQL_FILTER=province='浙江省' and city not in ('" + cityNameList.join("','") + "')";
    let filterStr = "&CQL_FILTER=city  in ('" + cityNameList.join("','") + "')";
    url += filterStr;
    const xhr = new XMLHttpRequest()
    xhr.open('GET', url);
    const onError = function () {
    }
    xhr.onerror = onError;
    xhr.onload = function () {
        if (xhr.status == 200) {
            clipFeatures = commVectorSource.getFormat().readFeatures(xhr.responseText, {
                dataProjection: 'EPSG:4326',
                featureProjection: 'EPSG:3857'
            });
            displayLineConnectSource.clear(true);
            refreshAllGeoLayer();

        } else {
            onError();
        }
    }
    xhr.send(
    );
}


function removeClipLayer() {
    clipFeatures = [];
    displayLineConnectSource.clear(true);
    refreshAllGeoLayer();
}
function clearDisplayLineConnectLayer() {
    displayLineConnectSource.clear(true);
}   

function addClipData(data) {//获取图层

    // //可以生成一个clip，但有我们的用法有冲突。
    // //
    // const newcliplayer = addPolyon(clipLayer, data);
    // // clipLayerSource.addFeatures(data);
    // let _layer = window.global.map.getAllLayers();
    // _layer.forEach(l => {

    //     l.on('postrender', e => {
    //         // e.context.globalCompositeOperation = 'destination-in';
    //         const context = e.context;//getVectorContext(e);
    //         newcliplayer.getSource().forEachFeature(feature => {
    //             // vectorContext.drawFeature(feature, clipStyle);

    //             context.save();
    //             let coors = feature.getGeometry().getCoordinates()[0];
    //             let pointArr = [];
    //             for (let i = 0; i < coors.length; i++) {
    //                 let coorTmp = coors[i];
    //                 let pointTmp = [];
    //                 for (let j = 0; j < coorTmp.length; j++) {
    //                     pointTmp.push(window.global.map.getPixelFromCoordinate(coorTmp[j]));
    //                 }
    //                 pointArr.push(pointTmp);
    //             }
    //             // context.globalCompositeOperation = "destination-in";
    //             context.beginPath();
    //             for (let i = 0; i < pointArr.length; i++) {
    //                 let pointTmp = pointArr[i];
    //                 for (let j = 0; j < pointTmp.length; j++) {
    //                     if (j == 0) {
    //                         context.moveTo(pointTmp[j][0], pointTmp[j][1]);
    //                     } else {
    //                         context.lineTo(pointTmp[j][0], pointTmp[j][1]);
    //                     }
    //                 }
    //             }
    //             context.closePath();
    //             context.fillStyle = "#ff0000";
    //             context.fill();
    //             context.restore();

    //         });
    //         // e.context.globalCompositeOperation = 'source-over';
    //     });
    // });
}

function drawSpecialLine(show) {
    if (clipFeatures.length > 0 || show  || window.global.applicationScene=='asia')
        return;//地区选择时，不显示省外线路
    let curZoom = window.common.getMapZoomInt(); //获取当前地图的缩放级别
    for (let i = 0; i < window.global.drawLineCfg.length; i++) {
        //draw specaile line
        let l = window.global.drawLineCfg[i];
        let style = window.common.safeGetJsonKey(l, "style", {});
        let points = []
        for (let p = 0; p < l.points.length; p++) {
            points.push(transform(l.points[p], 'EPSG:4326', 'EPSG:3857'))
        }

        let colorV = l.color;
        let vVal = window.common.safeGetJsonKey(l, "voltageLevel", "");
        if (vVal != "") {
            if (voltageLevelFilter.length > 0) {
                if (!window.common.valIsInArray(voltageLevelFilter, vVal)) {
                    continue;
                }
            }

            let item = window.common.getVoltageInfo(vVal);
            let autoMinZoom = parseInt(item.minZoom);
            if (curZoom < autoMinZoom)
                continue;
            colorV = item.color;
        }

        let olfeature = new Feature({
            geometry: new LineString(points),
            name: l.name
        });

        olfeature.setStyle(() => {
            return new Style({

                stroke: new Stroke({
                    color: colorV, //颜色
                    width: l.width, //宽度
                    lineDash: [3, 3]
                }),
            })
        }); //设置要素样式
        displayLineConnectSource.addFeature(olfeature)
        if (l.name != null && curZoom >= 10) {
            let subObj = {
                text: {
                    "fontSize": 12,
                    "font": window.common.safeGetJsonKey(style, "font", mapCfg.text.font),
                    "fill": window.common.safeGetJsonKey(style, "fill", getElementColorByGB("fill","auto")),
                    "color": window.common.safeGetJsonKey(style, "color", getElementColorByGB("color","auto")),
                }
            };
            saveLineLabelInfo(displayLineConnectLayer, olfeature, subObj, l.name)
        }


        let vEndof = window.common.safeGetJsonKey(l, "endof", "");
        // let vEndof = window.common.safeGetJsonKey(l,"name","");
        if (vEndof != "") {
            let subObj = {
                text: {
                    "fontSize": 12,
                    "font": window.common.safeGetJsonKey(style, "font", mapCfg.text.font),
                    "fill": window.common.safeGetJsonKey(style, "fill", getElementColorByGB("fill","auto")),
                    "color": window.common.safeGetJsonKey(style, "color", getElementColorByGB("color","auto")),
                    "offsetY": "-2",
                    "offsetX": "0",
                }
            };
            let olPfeature = new Feature({
                geometry: new Point(points[points.length - 1]),
                name: l.name
            });
            olPfeature.setStyle(() => {
                return new Style({

                    image: new olCircle({
                        radius: 2,
                        fill: new olFill({
                            color: colorV
                        }),
                    })
                })
            }); //设置要素样式

            displayLineConnectSource.addFeature(olPfeature);

            // saveLineLabelInfo(displayLineConnectLayer,olfeature,subObj,l.name)
            savePointLabelInfo(displayLineConnectLayer, "",curZoom, subObj, vEndof, olPfeature, 1, 8);
        }


    }

}

function drawSationConnectLine() {
    let clearOldData = true;

    displayLineConnectLayer.setVisible(true);


    let curZoom = window.common.getMapZoomInt(); //获取当前地图的缩放级别
    if (curZoom <= 12)
        return;

    let minConnectLine = mapCfg.minConnectLine;
    let subStationConnect = mapCfg.subStationConnect;
    let mapRect = map.getView().calculateExtent(map.getSize());
    for (let i = 0; i < subStationConnect.length; i++) {
        let l = subStationConnect[i];
        let lname = l.centerLayer;
        let ly = getLayerByName(lname, 0)[0];
        if (ly == null || ly.ol == null)
            continue

        let centerIdField = l.id;
        let cfeatures = ly.ol.getSource().getFeaturesInExtent(mapRect);
        for (let ci = 0; ci < cfeatures.length; ci++) {
            let fetProp = window.common.getFeatureProperties(cfeatures[ci]);
            let tid = window.common.safeGetJsonKey(fetProp, centerIdField, "");
            if (tid == "")
                continue;
            let edgeLayer = l.edgeLayer;
            let cc = cfeatures[ci].getGeometry().getFlatCoordinates();
            let center = transform(cc, 'EPSG:3857', 'EPSG:4326');
            var from = turf.point(center);
            for (let ei = 0; ei < edgeLayer.length; ei++) {
                let et = edgeLayer[ei];
                let ely = getLayerByName(et.name, 0)[0];
                if (ely == null || ely.ol == null)
                    continue
                let idfieldList = et.id
                let efeatures = ely.ol.getSource().getFeatures();//getFeaturesInExtent(mapRect);
                for (let ce = 0; ce < efeatures.length; ce++) {
                    let cee = efeatures[ce];
                    let efetProp = window.common.getFeatureProperties(cee);
                    for (let idd = 0; idd < idfieldList.length; idd++) {
                        let eid = window.common.safeGetJsonKey(efetProp, idfieldList[idd], "");
                        if (eid == tid) {
                            let coors = cee.getGeometry().getFlatCoordinates();
                            let cc = [coors[0], coors[1]];
                            let to = turf.point(transform(cc, 'EPSG:3857', 'EPSG:4326'));
                            let distance = turf.distance(from, to, { units: 'kilometers' });
                            let cc1 = [coors[coors.length - 2], coors[coors.length - 1]];
                            let to1 = turf.point(transform(cc1, 'EPSG:3857', 'EPSG:4326'));
                            let distance1 = turf.distance(from, to1, { units: 'kilometers' });
                            if (distance1 < distance) {
                                cc = cc1;
                                distance = distance1;
                            }


                            if (distance * 1000 > minConnectLine)
                                continue;
                            {
                                let olfeature = new Feature({
                                    geometry: new LineString([
                                        transform(center, 'EPSG:4326', 'EPSG:3857'),
                                        cc]),
                                    name: ""
                                });
                                // console.log(transform(cc, 'EPSG:3857', 'EPSG:4326'), efetProp.name);
                                let colorV = "#8d8d8d";
                                let vField = ely.voltageFiled;
                                if (vField != "") {
                                    let val = window.common.safeGetJsonKey(efetProp, vField, "--**--");
                                    if (val != '--**--') {
                                        let v = window.common.getVoltageInfo(val);
                                        colorV = v.styleInfo.hex;
                                    }
                                    else {
                                        console.log("impossbile!!!!");
                                    }
                                    // console.log(val,colorV,vField);
                                }

                                olfeature.setStyle(() => {
                                    return new Style({

                                        stroke: new Stroke({
                                            color: colorV, //颜色
                                            width: 1, //宽度
                                            lineDash: [3, 3]
                                        }),
                                    })
                                }); //设置要素样式
                                displayLineConnectSource.addFeature(olfeature)
                            }
                        }
                    }
                }

            }
        }

    }
}

function drawSationConnectLine_demo() {

    let centerPoint, centerLayer = [];
    let edgeList = [];
    let edgeLayer = [];
    let minLen = 0;
    if (curZoom <= 12)
        return;

    displayLineConnectSource.clear();
    for (let i = 0; i < layerCfg.length; i++) {
        let jl = layerCfg[i];
        let ly = jl.ol;
        if (ly == null)
            continue;
        if (!ly.getVisible())
            continue;
        let e = parseInt(window.common.safeGetJsonKey(jl, "subStationCenter", 0));
        if (e == 1)
            centerLayer.push(jl);
        else {
            e = parseInt(window.common.safeGetJsonKey(jl, "subStationEdge", 0));
            if (e == 1)
                edgeLayer.push(jl);
        }
    }
    if (centerLayer.length == 0 || edgeLayer.length == 0)
        return;
    let mapRect = map.getView().calculateExtent(map.getSize());
    let cfeatures = [];
    for (let ll = 0; ll < centerLayer.length; ll++) {
        cfeatures = cfeatures.concat(centerLayer[ll].ol.getSource().getFeaturesInExtent(mapRect));
    }

    let minConnectLine = mapCfg.minConnectLine;


    for (let ll = 0; ll < edgeLayer.length; ll++) {
        let efeatures = edgeLayer[ll].ol.getSource().getFeatures();//getFeaturesInExtent(mapRect);
        for (let ci = 0; ci < cfeatures.length; ci++) {

            let cc = cfeatures[ci].getGeometry().getFlatCoordinates();
            let center = transform(cc, 'EPSG:3857', 'EPSG:4326');
            var from = turf.point(center);
            for (let ce = 0; ce < efeatures.length; ce++) {
                let cee = efeatures[ce];
                let geom = cee.getGeometry();
                let points = [];
                let coor;
                if (geom.getType() == "MultiLineString") {
                    // if(cee.values_.name=="象松4P25线")
                    // {
                    //     console.log("11");
                    // }
                    let coors = window.common.sortLineCoordinates(geom.getLineStrings());


                    // let olfeature = new Feature({
                    //     geometry: new LineString(coors[1]),
                    //     name: ""
                    // });
                    // let colorV="#fd0d8d";

                    // olfeature.setStyle(() => {
                    //     return new Style({

                    //         stroke: new Stroke({
                    //             color: colorV, //颜色
                    //             width: 5, //宽度
                    //             lineDash:[3,3]
                    //         }),
                    //     })
                    // }); //设置要素样式

                    // displayLineConnectSource.addFeature(olfeature)
                    coor = coors[0];
                }
                else
                    coor = geom.getFlatCoordinates();

                if (coor.length <= 2) {
                    points.push(transform([coor[0], coor[1]], 'EPSG:3857', 'EPSG:4326'));
                }
                else {
                    points.push(transform([coor[0], coor[1]], 'EPSG:3857', 'EPSG:4326'));
                    points.push(transform([coor[coor.length - 2], coor[coor.length - 1]], 'EPSG:3857', 'EPSG:4326'));
                }
                if (points.length >= 2) {
                    minLen = 100.0;
                    let minPos = []
                    for (let l = 0; l < points.length; l++) {
                        let to = turf.point(points[l]);
                        var distance = turf.distance(from, to, { units: 'kilometers' });
                        if (distance < minLen) {
                            minPos = points[l];
                            minLen = distance;
                        }
                    }

                    if (minLen * 1000 <= minConnectLine) {
                        let olfeature = new Feature({
                            geometry: new LineString([
                                transform(center, 'EPSG:4326', 'EPSG:3857'),
                                transform(minPos, 'EPSG:4326', 'EPSG:3857')]),
                            name: ""
                        });
                        let colorV = "#8d8d8d";
                        let vField = edgeLayer[ll].voltageFiled;
                        if (vField != "") {
                            let fetProp = window.common.getFeatureProperties(cee);
                            let val = window.common.safeGetJsonKey(fetProp, vField, "--**--");
                            if (val != '--**--') {
                                let v = window.common.getVoltageInfo(val);
                                colorV = v.styleInfo.hex;
                            }
                            else {
                                console.log("impossbile!!!!");
                            }
                            // console.log(val,colorV,vField);
                        }

                        olfeature.setStyle(() => {
                            return new Style({

                                stroke: new Stroke({
                                    color: colorV, //颜色
                                    width: 1, //宽度
                                    lineDash: [3, 3]
                                }),
                            })
                        }); //设置要素样式

                        displayLineConnectSource.addFeature(olfeature)
                    }
                }
            }
        }
    }

}
function getHeatLineLayer() {
    let getList = [];
    for (let i = 0; i < layerCfg.length; i++) {
        let jl = layerCfg[i];
        let ly = jl.ol;
        if(!jl.online)
            continue;
        if (ly == null)
            continue;
        // if (!ly.getVisible())
        //     continue;
        
        let h = parseInt(window.common.safeGetJsonKey(jl, "heatLine", "0"));
        if (h != 1)
            continue;
        getList.push(jl);
    }
    return getList;
}

// var lineDedalut = null;

// var hightLightStyle = new Style({
//     //填充色
//     fill: new olFill({
//         color: 'rgba(55, 125, 355, 0.6)'
//     }),
//     //边线颜色
//     stroke: new Stroke({
//         color: '#55aaff',
//         width: 3
//     }),
//     //形状
//     image: new olCircle({
//         radius: 7,
//         fill: new olFill({
//             color: '#ffcc33'
//         })
//     })
// })

// var highLightFeature = null;
var selectedFeature = null;


function markVenueRelation(feature)
{
    let idField;
    let nameField;
    let fetProp = window.common.getFeatureProperties(feature);
    let reationId=window.getRelationFeatureId(fetProp.id)
    let jl=null;
    for (let f in reationId) {
        jl=getLayerByName(f,0)[0]
        if(jl==null)
            continue
        reationId[f].forEach((item) => {
            idField = window.common.safeGetJsonKey(jl, "idfield", window.global.mapCfg.text.idfield);
            nameField = window.common.safeGetJsonKey(jl, "textfield", window.global.mapCfg.text.textfield);
            jl.ol.getSource().getFeatures().forEach((feat) => {
                let fetP = window.common.getFeatureProperties(feat);
                let tid = window.common.safeGetJsonKey(fetP, idField, "");
                if(tid == item)
                { 
                    let tname = window.common.safeGetJsonKey(fetP, nameField, "");
                    let olfeature = new Feature({
                        geometry: feat.getGeometry(),
                        name: tname
                    })
                    displaySelectedSource.addFeature(olfeature);
                }
            }); 
        }); 

    }
    return jl;
}

function addPointerMoveEvent() {

    // 设置高亮要素变量
    map.on('pointerup', function(evt) {
          window.mapWeather.weatherTipDragOver(evt);
      });

    map.on('pointermove', function (e) {
        if (e.dragging) {
            window.mapWeather.weatherTipDragging(e);
            return;
        }
        var features = map.forEachFeatureAtPixel(e.pixel, function (feature, layer) {
            // console.log(feature);
            return {
                feature: feature,
                layer: layer
            };
        },
            {
                hitTolerance: 10,
                //点击时允许鼠标的误差
            });

        if (selectedFeature != null) {
        //     displaySelectedSource.clear(true);
            selectOverlay.setPosition(undefined);
        }
        window.setMeasurementItem && window.setMeasurementItem(true,{},[])
        let gtype = "";
        if (features) {
            let jl = null;
            let v = window.common.safeGetJsonKey(features.feature, "values_", null);
            if (v != null)
                jl = window.common.safeGetJsonKey(v, "layer", null);
            else    
                return ;
            if (jl != null && !jl.pointerMove) {
                map.getTargetElement().style.cursor = '';
                window.setSiteInformation(null);
                stopWeatherTipTimer();
                return;
            }
            gtype = features.feature.getGeometry().getType();
            console.log()
            let nFlag = false;
            if (gtype == "LineString" || gtype == "MultiLineString" || gtype == "Point" || gtype == "MultiPoint")
                nFlag = true;
            if (nFlag) {
                map.getTargetElement().style.cursor = 'pointer';
            }
            else {
                map.getTargetElement().style.cursor = '';
                window.setSiteInformation(null);
                stopWeatherTipTimer();
                return;
            }
            if (selectedFeature != null) {
                clearDisplaySelectedSource();
                selectOverlay.setPosition(undefined);
            }
            let fetProp;
            let nameField;
            let tname;
            let tid;
            let idField;
            let measValue
            let meas
            
            if(features.layer == window.global.qzbdMeasDisplayLayer)
            {
                jl = window.global.qzbdMeasDisplayLayer
                fetProp = window.common.getFeatureProperties(features.feature);
                tname = window.common.safeGetJsonKey(fetProp, "name", "");
                measValue = window.common.safeGetJsonKey(fetProp, "measValue", "");
                meas=fetProp["meas"]
                window.setMeasurementItem && window.setMeasurementItem(false,v,e.coordinate)
                return

            }
            else if(features.layer == window.global.aisaLayerLayer)
            {
                jl=markVenueRelation(features.feature)
                fetProp = window.common.getFeatureProperties(features.feature);
                selectedFeature = features.feature;
                nFlag =0;
                tname = window.common.safeGetJsonKey(fetProp, "name", "");


            }
            else if (features.layer == displayLabelLayer) {

                jl = features.feature.values_.layer;
                if (jl == null) {
                    window.setSiteInformation(null);
                    selectOverlay.setPosition(undefined);
                    stopWeatherTipTimer();
                    return;
                }

                // let idField = window.common.safeGetJsonKey(jl, "idfield", window.global.mapCfg.text.idfield);
                // let tid = window.common.safeGetJsonKey(fetProp, idField, "");
                // let alFeatures=jl.ol.getSource().readFeatures;


                selectedFeature = features.feature.values_.fixedFeature;
                fetProp = window.common.getFeatureProperties(selectedFeature);
                nameField = window.common.safeGetJsonKey(jl, "textfield", window.global.mapCfg.text.textfield);
                tname = window.common.safeGetJsonKey(fetProp, nameField, "");

            }
            else if (features.layer == displayLineConnectLayer) {
                selectedFeature = features.feature;
                jl = null;
                fetProp = window.common.getFeatureProperties(selectedFeature);
                tname = window.common.safeGetJsonKey(fetProp, "name", "");
            }
            
            else {
                let flag = false
                if(features.feature.values_.name =='test'){
                    flag = true
                    
                    jl = getLayerCfgBylayerTower(features.layer);
                }else{
                    jl = getLayerCfgBylayer(features.layer);
                    if (jl == null) {
                        window.setSiteInformation(null);
                        selectOverlay.setPosition(undefined);
                        return;
                    }
                }
                
                selectedFeature = features.feature;
                fetProp = window.common.getFeatureProperties(selectedFeature);
                nameField = window.common.safeGetJsonKey(jl, "textfield", window.global.mapCfg.text.textfield);
                if(flag){
                    tname = features.feature.get('class_name')
                }else{
                    tname = window.common.safeGetJsonKey(fetProp, nameField, "");
                }
                
            }


            if (nFlag ) {
                if (selectedFeature != null) {
                    clearDisplaySelectedSource();
                    selectOverlay.setPosition(undefined);
                }
                //   鼠标经过要素时，设置要素填充颜色，获取到颜色值则设置该值，获取不到则设置为yellow
                // selectedStyle.getFill().setColor(selectedFeature.get("color") || "yellow");
                let olfeature = new Feature({
                    geometry: selectedFeature.getGeometry(),
                    name: tname
                })
                displaySelectedSource.addFeature(olfeature);
            }

            if (jl == null) {
                // if (jl==null && !jl.leftMenu) {
                window.setSiteInformation(null);
                selectOverlay.setPosition(undefined);
                stopWeatherTipTimer();
                return;
            }
            if(window.global.topicName.includes("weather") )
            {
                if( gtype == "Point")
                {
                    stopWeatherTipTimer();
                    weatherTipDelay = setTimeout(() => {
                        let pos=selectedFeature.getGeometry().getCoordinates();
                        window.mapWeather.showPointWeather(pos,tname);
                    }, 1000) 
                
                }
                else 
                    stopWeatherTipTimer();
                return ;
            }
            let className = window.common.safeGetJsonKey(fetProp, jl.classNameField, "");
            tid = window.common.safeGetJsonKey(fetProp, jl.idField, "");
            let coordinate = e.coordinate;
            let pos = transform(coordinate, 'EPSG:3857', 'EPSG:4326')
            pos = [parseFloat(pos[0].toFixed(4)), parseFloat(pos[1].toFixed(4))]
            let tgeolayerNameType
            let tpower
            // console.log(tname, tid, fetProp, className, tgeolayerName);
            window.global.layerCfg.forEach((item) => {
                // console.log(item.geolayerName,'geolayerName')
                if (jl != null && item.geolayerName == jl.geolayerName) {
                    tgeolayerNameType = item.title;
                }
            })

            // window.global.tidwayFeatureAll.forEach((item) => {
            //     if (item.id == tid) {
            //         tpower =Math.abs (item.start_aclineend_val)+Math.abs (item.end_aclineend_val)
            //     }

            // })
            let dispInfo = [
                { title: "名称", "name": tname },
                { title: "ID", "name": tid },
                // { title: "电压等级", "name": voltageType },
                // { title: "表", "name": jl != null ? jl.geolayerName : "" },
                { title: "类型", "name": className },
                // { title: "功耗", "name": tpower },
                { title: "坐标", "name": pos }
            ]
            window.setSiteInformation(dispInfo);
            selectOverlay.setPosition(e.coordinate);
        
        }
        else {
            map.getTargetElement().style.cursor = '';
            window.setSiteInformation(null);
            stopWeatherTipTimer();
        }



        // if (gtype == "LineString" || gtype == "MultiLineString") {
        //     highLightFeature = features.feature;
        //     features.feature.setStyle(hightLightStyle);
        // } else {
        //     if (highLightFeature) {
        //         let st=getFeatureStyle(highLightFeature,"geoJson");
        //         highLightFeature.setStyle(st);
        //         highLightFeature = null;
        //     }
        // }
    });

}
function getMapScale()
{
    let mScale=0;
    const DEFAULT_DPI = 25.4 / 0.28;
    //每米多少英寸
    const inchesPerMeter = 1000 / 25.4;
    let resolution = window.global.map.getView().getResolution();

    //如果是度分秒的话需要转换为米
    if (window.global.map.getView().getProjection().getUnits() != 'metric') {
        mScale = resolution * window.global.map.getView().getProjection().getMetersPerUnit() * inchesPerMeter * DEFAULT_DPI;
    } else {
        mScale = resolution * inchesPerMeter * DEFAULT_DPI;
    }
    return parseInt(mScale)
}
var lastScale=0;
var currentScale = 1;
function resolutionChange() {
    // currentScale = getMapScale();
    // console.log(lastScale,currentScale)
    //     if(lastScale ==17471320 && currentScale>= 17426000 &&  currentScale<=17434000)
    //     {
    //         let p2385Rect=[];
    //         let tp = transform([jumpExtenList[1][0], jumpExtenList[1][1]], 'EPSG:4326', 'EPSG:3857');
    //         let br = transform([jumpExtenList[1][2], jumpExtenList[1][3]], 'EPSG:4326', 'EPSG:3857');
    //         p2385Rect[0]=tp[0];
    //         p2385Rect[1]=tp[1];
    //         p2385Rect[2]=br[0];
    //         p2385Rect[3]=br[1];
    //         setTimeout(() => {
    //             map.getView().fit(p2385Rect, {
    //                 constrainResolution: true,
    //                 nearest: true
    //             })
    //         }, 500);
            
    //     }
    //     else if(lastScale>=5460000 && lastScale <=6000000 &&  
    //         ((currentScale>= 5440000 &&  currentScale<=5450000) || (currentScale>= 6825000 &&  currentScale<=6835000))
    //     )
    //     {
    //         let nextP;
    //         if(currentScale<lastScale)
    //         {
    //             nextP=2;
    //         }
    //         else
    //         {
    //             nextP=0;
    //         }

    //         let p2385Rect=[];
    //         let tp = transform([jumpExtenList[nextP][0], jumpExtenList[nextP][1]], 'EPSG:4326', 'EPSG:3857');
    //         let br = transform([jumpExtenList[nextP][2], jumpExtenList[nextP][3]], 'EPSG:4326', 'EPSG:3857');
    //         p2385Rect[0]=tp[0];
    //         p2385Rect[1]=tp[1];
    //         p2385Rect[2]=br[0];
    //         p2385Rect[3]=br[1];
    //         setTimeout(() => {
    //             map.getView().fit(p2385Rect, {
    //                 constrainResolution: true,
    //                 nearest: true
    //             })
                   
    //         }, 500);
    //     }
    //     else if(lastScale>= 2155000 && lastScale <= 2165000)
    //     {
    //         let nextP;
    //         if(currentScale<lastScale)
    //         {
    //             nextP=3;
    //         }
    //         else
    //         {
    //             nextP=1;
    //         }

    //         let p2385Rect=[];
    //         let tp = transform([jumpExtenList[nextP][0], jumpExtenList[nextP][1]], 'EPSG:4326', 'EPSG:3857');
    //         let br = transform([jumpExtenList[nextP][2], jumpExtenList[nextP][3]], 'EPSG:4326', 'EPSG:3857');
    //         p2385Rect[0]=tp[0];
    //         p2385Rect[1]=tp[1];
    //         p2385Rect[2]=br[0];
    //         p2385Rect[3]=br[1];

    //         setTimeout(() => {
    //             map.getView().fit(p2385Rect, {
    //                 constrainResolution: true,
    //                 nearest: true
    //             })
    //         }, 500);
    //     }
    //     else if(lastScale>= 1160000 && lastScale <= 1260000)
    //     {
    //         let nextP;
    //         if(currentScale>lastScale)
    //         {
    //             nextP=2;

    //             let p2385Rect=[];
    //             let tp = transform([jumpExtenList[nextP][0], jumpExtenList[nextP][1]], 'EPSG:4326', 'EPSG:3857');
    //             let br = transform([jumpExtenList[nextP][2], jumpExtenList[nextP][3]], 'EPSG:4326', 'EPSG:3857');
    //             p2385Rect[0]=tp[0];
    //             p2385Rect[1]=tp[1];
    //             p2385Rect[2]=br[0];
    //             p2385Rect[3]=br[1];

    //             setTimeout(() => {
    //                 map.getView().fit(p2385Rect, {
    //                     constrainResolution: true,
    //                     nearest: true
    //                 })
    //             }, 500);
    //         }
    //     }
    // lastScale= currentScale;
}
function addResoultChangedEvent() {

    lastScale = getMapScale();
    // document.addEventListener('DOMMouseScroll',resolutionChange,false);
    // document.getElementById("map").onmousewheel=resolutionChange;
    // window.onmousewheel=document.onmousewheel= resolutionChange;

    // map.getView().on('change:resolution', function () {
    map.getView().on('change:resolution', function () {
        //默认dpi
        resolutionChange();
    });

}


function hideSelectOverlay()
{
    selectOverlay.setPosition(undefined);
}

function appendbreakDownLayerFeatuer(olfeature, cleanit) {
    if (cleanit) {
        breakDownSource.clear(true);
    }
    breakDownSource.addFeature(olfeature);
}

function clearbreakDownLayerFeatuer() {
    breakDownSource.clear(true);
}
function drawWeatherFlag(coors)
{
    //no using 
    let canvas = document.createElement('canvas');
    let context = canvas.getContext('2d',{willReadFrequently: true});
    let w=80;
    let h=25
    let r=12;
    let mh=80
    context.fillStyle = 'rgba(68,65,65,0.84)';
    // context.fillStyle =' rgba(255, 255, 255, 0)';
    context.strokeStyle = 'rgba(68,65,65,0.84)';
    context.lineWidth=2
    context.beginPath();
    context.moveTo(4, 0);
    context.lineTo(4, mh);
    context.moveTo(4, mh-4);
    context.arc(4,mh-4,3,0,2*Math.PI);
    // context.lineTo(0, 0);
    context.moveTo(4, 0);
    // context.lineTo(w, 0);
    // context.lineTo(w, h);
    // context.lineTo(0, h);
    // context.lineTo(0, 0);
    context.fillRect(6,0,w-6,h);
    context.moveTo(w, 0);
    context.arc(w,r,r,1.5*Math.PI,0.5*Math.PI);
    // context.fillStyle = 'rgba(245,245, 245,0.9)';
    // context.moveTo(0, h*4);
    // context.arc(0,0,10,0,2*Math.PI);
    // context.fill();
    // context.moveTo(0, 0);
    // context.lineTo(w, 0);
    // context.lineTo(w, h);
    // context.lineTo(0, h);
    // context.fill()
    // context.shadowColor='rgba(0,0,0,0.2)';
    // context.shadowBlur=10;
    // context.shadowOffsetX=5;
    // context.shadowOffsety=5;
    context.moveTo(0, 0);
    context.closePath();
    context.fill();
    context.stroke();
    context.fillStyle = 'white';
    context.font="20px bold 微软雅黑";
    context.fillText("20℃",10,h/2+8);
    let olfeature = new Feature({
        geometry: new Point(coors), //几何信息
        name: "",
    });
    olfeature.setStyle(() => {
        return new Style({
            image: new olIcon({
                img: canvas,
                imgSize: [w+r+8, mh],
                anchor: [0, 1],
                // declutterMode:"declutter"
                // offsetX:-parseInt(w/2)-10,// parseInt(subObj.text.offsetX),
                // offsetY:parseInt(h/2)-3,
            })
        })
    }); //设置要素样式
    clearDisplaySelectedSource()
    displaySelectedSource.addFeature(olfeature);
}

function clearDisplaySelectedSource()
{
    displaySelectedSource.clear(true);
}

function getElementColorByGB(fillorcolor,color)
{
    let curBg=window.global.bgColor;
    // let curBg="light";
    let cl=color.split("/");
    if(cl.length>=2)
    {
        // rgba(200,199,180,0.7)/rgba(30,29,20,0.3)
        if(curBg=="dark")
            return cl[1];
         else
            return cl[0];
    }
    else if(cl[0]!="auto")
    {
        // rgba(200,199,180,0.7)
        return cl[0]
    }
    else 
    {
        // auto
        return mapCfg.text[curBg+fillorcolor];
    }
}


function isAsiaFilting()
{
    return window.global.applicationScene=='asia' && window.isAsiaFilting();
}
function stopWeatherTipTimer()
{
    if(weatherTipDelay!=null)
    {
        clearTimeout(weatherTipDelay);
        weatherTipDelay=null;
    }
}

function restoreMapExten()
{
    
    map.getView().fit(initExten, {
        constrainResolution: true,
        nearest: true
    })

    // let mapCenterXY = [
    //   parseFloat(mapCfg.centerX),
    //   parseFloat(mapCfg.centerY)
    // ];
    // let view = map.getView();
    // let zoom = view.getZoom();
    // view.setCenter(fromLonLat(mapCenterXY));
    // view.setZoom(parseFloat(mapCfg.defaultZoom));
 };


export default {
    createMap,    //建立地图
    getLayerByName, //根据层的名称 取得层的结构。
    getLayerBygeoName,
    getFeaturesInExtentbygeoJson, // 取前当前在在视图内所有（可见）对象.
    setTempFilter,//设置变电站、电厂类型、电压级别三个临时过滤，在图层控制界面的 电压、电压类型、变电站类型
    setMapCenter,
    setMapZoom,
    getLayerCfgBylayer,
    getHeatLineLayer,
    initMapBase,
    initgraphdata,
    removeClipLayer,
    createClipLayer,
    refreshAllGeoLayer,
    cleanDisplayLayer,
    refreshGeoLayer,
    clearDisplayLabelSource,
    appendbreakDownLayerFeatuer,
    clearbreakDownLayerFeatuer,
    getFeatureStyleEx,
    getFeatureStyle,
    clearDisplayLineConnectLayer,
    clearDisplaySelectedSource,
    hideSelectOverlay,
    stopWeatherTipTimer,
    getElementColorByGB,
    markVenueRelation,
    getAisaFilterlayer,
    displayLayerbyZoom,
    getMapInitExten,
    restoreMapExten,
    flytoExtenLocation,
    flytoAsiaExtenLocation

}

